<template>


    <!-- font awsome --> <!-- App Css-->
    <!-- Costume Css-->
    <div class="layout-wrapper d-lg-flex justify-content-center" data-layout-mode="dark">

        <!-- start chat-leftsidebar -->
        <div id="chat-leftsidebar" class=" border-r">
            <!-- Start chats tab-pane -->

            <!-- End chats tab-pane -->
            <!-- end tab content -->
        </div>
        <!-- end chat-leftsidebar -->

        <!-- Start User chat -->
        <div :class="isModalKharid == true || isModalNewUser == true || isModalReferral == true || isModalQuestion == true || isModalCategory == true || isModalVisible == true || isModalVersion == true ? 'custom' : ''"
            class="mx-1200 user-chat w-100 overflow-hidden border-l">
            <div class="chat-content d-lg-flex">
                <!-- start chat conversation section -->
                <div class="mx-1200 w-100 overflow-hidden position-relative">
                    <!-- conversation user -->
                    <div id="users-chat" class="position-relative">
                        <div class="py-3 user-chat-topbar">
                            <div class="row align-items-center">
                                <div class="col-sm-4 col-10">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 overflow-hidden">
                                            <div class="d-flex align-items-center">
                                                <div
                                                    class="flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0">
                                                    <img :src="iconofchat" class="rounded-circle avatar-sm" alt="">
                                                    <span class="user-status"></span>
                                                </div>
                                                <div class="flex-grow-1 overflow-hidden">

                                                    <h6 class="text-truncate mb-0 fs-15">
                                                        <a href="#" class="user-profile-show text-white">{{ nameofchat
                                                            }}</a>
                                                    </h6>
                                                    <a v-if="this.history.length == 0 && this.chats.length == 0"
                                                        @click="gotoCharacters()" id="taghirShakhsiat" class="btn btn-sm btn-primary"
                                                        style="margin-top: 5px;">تغییر شخصیت</a>
                                                    <a v-else @click="deleteConversation()" id="hazfGoftogo"
                                                        class="btn btn-sm btn-danger" style="margin-top: 5px;">حذف
                                                        گفتگو</a>
                                                    
                                                </div>
                                                <button @click="gotoBack()"
                                                    class="p-button p-component tu-button btn-tertiary backBtn_U6DGe"
                                                    style="position: absolute;left:15px" type="button">
                                                    <i class="fa-solid fa-arrow-left"
                                                        style="font-size:20px;color:rgb(209, 208, 208)"></i>
                                                </button>
                                                <div @click="isModalVersion = true" id="taghirAiVersion"
                                                    style="position: absolute;left:50px;display:flex;text-align: center;border-radius: 30px;padding:5px;margin-top:5px;margin-bottom:5px;height:2.5em;background: rgb(97,83,204);background: linear-gradient(90deg, rgb(106, 94, 202) 20%, #fd7691 100%);cursor: pointer;">
                                                    <h3 style="margin-right:5px;margin-left: 5px;margin-top:3.5px;color:white;font-weight: bold;font-family: IRANSansWeb;font-size:14px"
                                                        class="pageTitle_36g65">مدل {{ aiVersion }} <i class="fa-solid fa-caret-down"></i></h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <!-- end chat user head -->
                        <!-- start chat conversation -->
                        <div class="chat-conversation p-3 p-lg-4 safty-margin" id="chat-conversation"
                            data-simplebar="init" style="height: calc(100vh - 94px);">
                            <div class="simplebar-wrapper" style="margin: -24px;">
                                <div class="simplebar-height-auto-observer-wrapper">
                                    <div class="simplebar-height-auto-observer"></div>
                                </div>
                                <div class="simplebar-mask">
                                    <div class="simplebar-offset" style="left: 0px; bottom: 0px;">
                                        <div class="simplebar-content-wrapper" id="scroller"
                                            style="height: 100%;  overflow: hidden scroll;">
                                            <div class="simplebar-content" style="padding: 24px;">
                                                <ul v-if="this.history.length > 0"
                                                    class="list-unstyled chat-conversation-list start-chat"
                                                    id="conversation-area">
                                                    <!-- conversation created here -->
                                                    <li v-for="(item, index) in history" :key="item.id"
                                                        v-bind:class="{ 'right': item.role === 'assistant' }"
                                                        class="chat-list left id chat-list-1">
                                                        <div v-if="item.role == 'assistant'"
                                                            class="right conversation-list">
                                                            <div class="user-chat-content">
                                                                <div data-v-96f3dc52=""
                                                                        class="flex-shrink-0 chat-user-img online user-own-img align-self-center ms-3 ms-0" style="margin-left: -5px;margin-bottom: 10px;">
                                                                        <span style="margin-left: 10px;color:white;font-weight: bold;font-size: 16px;">{{ nameofchat }}</span>
                                                                        <img data-v-96f3dc52="" :src="iconofchat"
                                                                            class="rounded-circle avatar-sm" alt="">
                                                                        
                                                                    </div>
                                                                <div style="margin-left:-10px" class="ctext-wrap">
                                                                    <div :id="'text' + index" style="color: white"
                                                                        class="user-text">
                                                                        <span
                                                                            style="position:absolute;bottom:5px;right:10px"
                                                                            class="text-success check-message-icon"><i
                                                                                class="fa-solid fa-check"></i></span>
                                                                        <p style="margin-right: 10px;"
                                                                            class="rtl-dir mb-0 ctext-content text-white p-chat">
                                                                            <img v-if="this.character == 'roboimage' && item.role == 'assistant'"
                                                                                :src="'https://api.roboo.ir/content/ImageGeneration/' + item.chat"
                                                                                style="max-width: 100%;max-height: 100%;"
                                                                                @click="this.imageSource = 'https://api.roboo.ir/content/ImageGeneration/' + item.chat; this.showImage = true"
                                                                                :class="item.id != this.history.length ? 'fa-solid fa-check-double' : 'fa-solid fa-check'" />
                                                                        </p>
                                                                    </div>
                                                                    
                                                                </div>
                                                                <div class="conversation-name">
                                                                    <button :id="'delete' + item.id"
                                                                        data-toggle="tooltip" data-placement="top"
                                                                        title="حذف" @click="deletes(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-trash"></i>
                                                                    </button>
                                                                    <button :id="'talk' + item.id" data-toggle="tooltip"
                                                                        data-placement="top" title="گفتار"
                                                                        @click="audioHistory(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-volume-high"></i>
                                                                    </button>
                                                                    <button :id="'like' + item.id" data-toggle="tooltip"
                                                                        data-placement="top" title="لایک"
                                                                        @click="like(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-thumbs-up"></i>
                                                                    </button>
                                                                    <button :id="'dislike' + item.id"
                                                                        data-toggle="tooltip" data-placement="top"
                                                                        title="دیس لایک" @click="dislike(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-thumbs-down"></i>
                                                                    </button>
                                                                    <button data-toggle="tooltip" data-placement="top"
                                                                        title="کپی" v-clipboard:copy="item.chat"
                                                                        @click="copy(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i :id="'copy' + item.id"
                                                                            class="fa-solid fa-clipboard"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="item.role == 'user'" class="conversation-list">
                                                            <div class="user-chat-content">
                                                                <div class="ctext-wrap">
                                                                    <div class="user-text"
                                                                        style="background-color: #6355cc !important">
                                                                        <img v-if="item.imageurl != ''"
                                                                            :style="isMobile == true ? 'height: 70vw;width: 70vw;margin-bottom: 10px;border-radius: 10px;margin-top:10px;object-fit: cover;' : 'height: 25vw;width: 25vw;margin-bottom: 10px;border-radius: 10px;margin-top:10px;object-fit: cover;'"
                                                                            :src="item.imageurl" />
                                                                        <span
                                                                            style="position:absolute;bottom:6px;right:10px"
                                                                            class="text-success check-message-icon"><i
                                                                                style="color: #06D6A0"
                                                                                :class="item.id != this.history.length ? 'fa-solid fa-check-double' : 'fa-solid fa-check'"></i></span>
                                                                        <p style="margin-right: 10px;"
                                                                            class="rtl-dir mb-0 ctext-content text-white ltr-dir p-chat">
                                                                            {{ item.chat }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>


                                                    <li class="line-break"><span>پایان گفتگو های قبلی</span></li>
                                                </ul>
                                                <ul class="list-unstyled chat-conversation-list"
                                                    id="conversation-area2">
                                                    <!-- conversation created here -->
                                                    <li data-v-96f3dc52="" class="right chat-list left id chat-list-1">
                                                        <div data-v-96f3dc52="" class="right conversation-list">
                                                        
                                                            <div data-v-96f3dc52="" class="user-chat-content">
                                                                <div data-v-96f3dc52=""
                                                                        class="flex-shrink-0 chat-user-img online user-own-img align-self-center ms-3 ms-0" style="margin-left: -5px;margin-bottom: 10px;">
                                                                        <span style="margin-left: 10px;color:white;font-weight: bold;font-size: 16px;">{{ nameofchat }}</span>
                                                                        <img data-v-96f3dc52="" :src="iconofchat"
                                                                            class="rounded-circle avatar-sm" alt="">
                                                                        
                                                                    </div>
                                                                <div data-v-96f3dc52="" style="margin-left:-10px"
                                                                    class="ctext-wrap">
                                                                    <div data-v-96f3dc52="" class="user-text">
                                                                        <p data-v-96f3dc52=""
                                                                            class="rtl-dir mb-0 ctext-content text-white p-chat">
                                                                            {{ this.welcomechat }}
                                                                        </p>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    
                                                    <li v-for="item in chats" :key="item.id"
                                                        v-bind:class="{ 'right': item.role === 'assistant' }"
                                                        class="chat-list left id chat-list-1">
                                                        
                                                        <div v-if="item.role == 'assistant'"
                                                            class="right conversation-list">
                                                            <div class="user-chat-content">
                                                                <!-- Memory Update Indicator for Assistant Messages -->
                                                                <div v-if="item.memoryUpdated" @click="openMemoryManagement()" class="memory-update-indicator">
                                                                    <div class="memory-update-box">
                                                                        <i class="fa-solid fa-file-pen" style="color: #6153cc; margin-left: 8px;"></i>
                                                                        <span style="color: #6153cc; font-size: 14px; font-family: IRANSansWeb;">حافظه بروزرسانی شد</span>
                                                                    </div>
                                                                </div>
                                                                <div data-v-96f3dc52=""
                                                                        class="flex-shrink-0 chat-user-img online user-own-img align-self-center ms-3 ms-0" style="margin-left: -5px;margin-bottom: 10px;">
                                                                        <span style="margin-left: 10px;color:white;font-weight: bold;font-size: 16px;">{{ nameofchat }}</span>
                                                                        <img data-v-96f3dc52="" :src="iconofchat"
                                                                            class="rounded-circle avatar-sm" alt="">
                                                                        
                                                                    </div>
                                                                <div class="ctext-wrap">
                                                                    <div :id="'text' + item.id" style="color: white"
                                                                        class="user-text">
                                                                        <p
                                                                            class="rtl-dir mb-0 ctext-content text-white p-chat">
                                                                            <img v-if="this.character == 'roboimage' && item.role == 'assistant'"
                                                                                :src="'https://api.roboo.ir/content/ImageGeneration/' + item.chat"
                                                                                style="max-width: 100%;max-height: 100%;"
                                                                                @click="this.imageSource = 'https://api.roboo.ir/content/ImageGeneration/' + item.chat; this.showImage = true"
                                                                                :class="item.id != this.history.length ? 'fa-solid fa-check-double' : 'fa-solid fa-check'" />
                                                                        </p>
                                                                    </div>
                                                                
                                                                </div>

                                                                <div class="conversation-name"><span
                                                                        class="text-success check-message-icon"><i
                                                                            class="fa-solid fa-check"></i></span>
                                                                    <button :id="'talk' + item.id" data-toggle="tooltip"
                                                                        data-placement="top" title="گفتار"
                                                                        @click="audio(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-volume-high"></i>
                                                                    </button>
                                                                    <button :id="'like' + item.id" data-toggle="tooltip"
                                                                        data-placement="top" title="لایک"
                                                                        @click="like(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-thumbs-up"></i>
                                                                    </button>
                                                                    <button :id="'dislike' + item.id"
                                                                        data-toggle="tooltip" data-placement="top"
                                                                        title="دیس لایک" @click="dislike(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i class="fa-solid fa-thumbs-down"></i>
                                                                    </button>
                                                                    <button data-toggle="tooltip" data-placement="top"
                                                                        title="کپی" v-clipboard:copy="item.chat"
                                                                        @click="copy(item.id)"
                                                                        class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                        <i :id="'copy' + item.id"
                                                                            class="fa-solid fa-clipboard"></i>
                                                                    </button>
                                                                </div>
                                                                <button
                                                                    v-if="this.showContinue == true && this.chats[this.chats.length - 1].id == item.id"
                                                                    style="margin-top:3px" @click="sendcontinue()"
                                                                    class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                    ادامه <i :id="'copy' + item.id"
                                                                        class="fa-solid fa-caret-down"></i>
                                                                </button>
                                                                <div  v-for="(item2, index) in suggestions" :key="index">
                                                                <button
                                                                v-if="this.chats[this.chats.length - 1].id == item.id"
                                                                    :style="{ marginTop: '5px', textAlign: getTextAlign(item2), display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'  }" @click="sendsuggestion(item2)"
                                                                    class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                                    <i class="fa-solid fa-caret-right" style="margin-left: 10px;"></i>
                                                                    <span style="unicode-bidi: plaintext;">{{ item2 }}</span>
                                                                </button>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="item.role == 'user'" class="conversation-list">
                                                            <div class="user-chat-content">
                                                                <div class="ctext-wrap">
                                                                    <div class="user-text"
                                                                        style="background-color: #6355cc !important;">
                                                                        <img v-if="item.imageUrl != null && item.imageUrl != ''"
                                                                        :style="isMobile == true ? 'height: 70vw;width: 70vw;margin-bottom: 10px;border-radius: 10px;margin-top:10px;object-fit: cover;' : 'height: 25vw;width: 25vw;margin-bottom: 10px;border-radius: 10px;margin-top:10px;object-fit: cover;'"
                                                                        :src="item.imageUrl" />
                                                                        <span
                                                                            style="position:absolute;bottom:6px;right:10px"
                                                                            class="text-success check-message-icon"><i
                                                                                style="color: #06D6A0"
                                                                                :class="item.id != this.chats.length ? 'fa-solid fa-check-double' : 'fa-solid fa-check'"></i></span>
                                                                        <p style="margin-right: 10px;"
                                                                            class="rtl-dir mb-0 ctext-content text-white ltr-dir p-chat">
                                                                            {{ item.chat }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                <br v-if="isMobile == false"/>
                                                <br v-if="isApplication == false">
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="simplebar-placeholder" style="width: auto; height: 357px;"></div>
                            </div>
                            <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                            </div>
                            <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                                <div class="simplebar-scrollbar"
                                    style="height: 320px; display: block; transform: translate3d(0px, 18px, 0px);">
                                </div>
                            </div>
                        </div>
                        <!-- end chat conversation end -->
                    </div>
                    <!-- conversation group -->

                    <!-- start chat input section -->
                    <div class="position-relative">
                        <div class="chat-reply-section px-4 py-1 pb-0 border-top">
                            <div class="row g-0 align-items-center">
                                <div class="col-auto reply-section-btn">
                                    <button class="btn btn-link btn-md reply-section-close-btn">
                                        <i class="fa fa-times align-middle"></i>
                                    </button>
                                </div>
                                <div class="col reply-section-text">
                                    text here...
                                </div>
                                <div class="col-auto reply-section-icon">
                                    <i class="bx bxs-share align-middle"></i>
                                </div>
                            </div>
                        </div>
                        <div v-if="showScrollToBottom"
     @click="scrollToBottom"
     class="scroll-to-bottom-fab">
  <i class="fa fa-arrow-down"></i>
</div>
                        <div class="chat-input-section ramin border-top" style="border-radius: 18px 18px 0 0">
                            <div v-if="this.pdfName !== ''"
                                style="margin-right:10px;margin-top:-15px;margin-bottom:5px">
                                <button @click="removePdf()" class="btn btn-info">
                                    <i class="fa-solid fa-x"
                                        style="margin-top:5px;margin-left:2px ;color:red;font-weight: bold"> </i>
                                    {{ this.pdfName }}
                                </button>
                            </div>
                            <div v-if="this.imageUrl != ''"
                                style="margin-right:10px;margin-top:-5px;margin-bottom:10px;">
                                <img :src="this.imageUrl" style="width: 90px; height: 90px; border-radius: 5px; object-fit: cover;" />
                                                                <i class="fa-solid fa-x" @click="removeImage()"
                                    style="position: absolute;top: 15px; right: 23px; color: white; font-size: 13px; font-weight: bold;background-color: rgba(0, 0, 0, 0.5); padding: 5px; border-radius: 50%;">
                                </i>
                            </div>
                            
                            <div id=" chatinput-form">
                                
                                <div class="col">
                                    <span style="margin-top:-10px;margin-bottom:7px;margin-right:5px" v-if="istyping" id="is-typing"
                                                    class="typing-user d-flex text-white">روبو
                                                    درحال
                                                    {{ roboStatus }}
                                                    <span style="margin-top:4px" class="typing ms-2">
                                                        <span class="dot"></span>
                                                        <span class="dot"></span>
                                                        <span class="dot"></span>
                                                    </span>
                                                </span>
                                        </div>
                                        <div class="position-relative">
                                            <div class="chat-input-feedback d-none">
                                                لطفا یک پیام بنویسید
                                            </div>
                                            <input class="d-none" type="hidden" id="_token"
                                                value="KOMMLg0FNGPyR4ya4nf2bf2ukqoAQxc2INZNv65MDgosIYCkn1xXpuPhczx05XGZ">
                                            <input class="d-none" type="hidden" id="reply-id-input" value="">
                                            
                                            <textarea
  autoresize
  id="textarea-input"
  autocomplete="off"
  type="text"
  class="form-control form-control-lg bg-light border-0 chat-input"
  v-on:keydown.enter="handleEnter"
  autofocus=""
  :value="chatbox"
  @focus="isSideBarOpen = false"
  @input="e => chatbox = e.target.value"
  placeholder="متن خود را بنویسید ..."
  style="text-align: start;unicode-bidi: plaintext;resize: none;border-radius:9px"
></textarea>
                                            <button id="voicebutton" v-if="this.chatbox == ''" @touchstart="start()"
                                                @mousedown="start()" @mouseup="end()" @touchend="end()"
                                                style="position: absolute;top: 0px; right: 5px; color: white; font-size: 20px; font-weight: bold;padding: 5px;"
                                                class="btn chat-send waves-effect waves-light">
                                                <i id="voiceicon" style="margin-top:5px"
                                                    class="fa-solid fa-microphone"></i>
                                            </button>


                                            

                                    </div>
                                <div class="row g-0 align-items-end" style="margin-top: 10px;justify-content: space-between;">
                                    <div class="col-auto" style="display: flex;">
                                    <div class="col-auto mar-left-5">
                                        <div class="chat-input-links gap-md-1">
                                            <div class="links-list-item">
                                                <button id="voicebutton2" v-if="this.istyping == true"
                                                    @click="stopChat()"
                                                    class="btn btn-primary btn-lg chat-send waves-effect waves-light">
                                                    <i id="voiceicon2" style="margin-top:7px"
                                                        class="fa-solid fa-stop"></i>
                                                </button>
                                                <button id="voicebutton2"
                                                    v-if="this.istyping == false && this.chatbox == ''"
                                                    @click="showVoice()"
                                                    class="btn btn-primary btn-lg chat-send waves-effect waves-light">
                                                    <i id="voiceicon2" style="margin-top:7px"
                                                        class="fa-solid fa-headphones-simple"></i>
                                                </button>
                                                <button v-if="this.istyping == false && this.chatbox != ''"
                                                    @click="checkConvThenPost()"
                                                    class="btn btn-primary btn-lg chat-send waves-effect waves-light">
                                                    <i class="fa-solid fa-paper-plane" style="margin-top:7px"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                    <div class="col-auto">
                                        <div class="chat-input-links ms-2 gap-md-1">
                                            <div style="position: relative; display: flex; align-items: center;">
    <!-- Selected Tools Chips (now before the button) -->
    <div v-for="tool in selectedTools" :key="tool.value" class="selected-tool-chip" style="margin-left: 5px;">
        <span :style="{ background: '#6355cc', color: 'white', borderRadius: '16px', padding: '8px', display: 'inline-flex', alignItems: 'center', fontSize: '14px', fontWeight: 'bold', marginLeft: '3px' }">
            <i :class="tool.icon" style="font-size: 17px; cursor: pointer;" @click="removeTool(tool.value)"></i>
            <i class="fa fa-times" style="margin-right: 6px; cursor: pointer;" @click="removeTool(tool.value)"></i>
        </span>
    </div>
    <!-- ابزار ها (Tools) Button -->
    <button
        ref="toolsBtn"
        id="abzarha"
        class="btn btn-info btn-lg chat-send"
        @click="toggleToolsMenu"
        style="display: flex; align-items: center; height: 43px; box-shadow: none; padding: 5px 8px 8px 8px; margin-left: 5px;"
    >
        <i class="fa-solid fa-toolbox" style="margin-top:6px"></i>
        <span style="margin-right:5px;font-size: 15px;margin-top:3px">ابزار ها</span>
    </button>
    <!-- Tools Dropdown Menu -->
    <div v-if="showToolsMenu" class="tools-dropdown" style="position: absolute; top: -180px; right: -90px; background: #232323; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.2); z-index: 10; min-width: 160px;">
        <div
            v-for="tool in toolsList"
            :key="tool.value"
            @click="selectTool(tool)"
            :style="{
                padding: '8px 12px',
                cursor: 'pointer',
                color: selectedTools.some(t => t.value === tool.value) ? '#fff' : '#ccc',
                background: selectedTools.some(t => t.value === tool.value) ? '#6355cc' : 'transparent',
                fontWeight: selectedTools.some(t => t.value === tool.value) ? 'bold' : 'normal'
            }"
        >
            <i :class="tool.icon" style="margin-left: 6px;"></i>
            {{ tool.label }}
        </div>
    </div>
</div>
                                            <div  class="links-list-item" id="addImage">
                                                
                                                <button  v-if="isSideBarOpen == false"
                                                    class="btn btn-info btn-lg chat-send" @click="isSideBarOpen = true">
                                                    <i class="fa-solid fa-plus" style="margin-top:6px"></i>
                                                </button>
                                                
                                                <label v-if="isSideBarOpen == true" for="file-upload"
                                                :class="chatSearch == true ? 'btn btn-danger btn-lg chat-send':'btn btn-info btn-lg chat-send'" style="margin-right:5px">
                                                    <i class="fa-solid fa-image " style="margin-top:9px;"></i>
                                                </label>
                                                <input v-if="chatSearch == false" id="file-upload" @change="onFileUploadImage"
                                                    style="display: none;" type="file" accept="image/*" />
                                                <label v-if="isSideBarOpen == true && isMobile == true"
                                                    for="take-picture" :class="chatSearch == true ? 'btn btn-danger btn-lg chat-send':'btn btn-info btn-lg chat-send'"
                                                    style="margin-right:5px">
                                                    <i class="fa-solid fa-camera " style="margin-top:9px;"></i>
                                                </label>
                                                <input v-if="chatSearch == false" id="take-picture" @change="onTakePicture" style="display: none;"
                                                    type="file" accept="image/*" capture />
                                                <button v-if="isSideBarOpen == true"
                                                    @click="this.isModalQuestion = true; this.isSideBarOpen = false;"
                                                    class="btn btn-info btn-lg chat-send" style="margin-right:5px;">
                                                    <i class="fa-solid fa-lightbulb" style="margin-top:6px;"></i>
                                                </button>
                                                <!-- <div style="margin-top: 5px" class="floating-btn">
                                                    <div class="options">
                                                        <label for="file-upload" class="option">PDF
                                                            <input id="file-upload" @change="onFileUpload"
                                                                style="display: none;" type="file"
                                                                accept="application/pdf,application/vnd.ms-excel" />
                                                        </label>

                                                        <div @click="this.isModalQuestion = true" class="option"
                                                            style="width: 82px;">
                                                            <a>متن آماده</a>
                                                        </div>
                                                        <div @click="showBezodi()" class="option">
                                                            <a>عکس</a>
                                                        </div>
                                                    </div>

                                                    <div class="main-btn btn btn-info">
                                                        <span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                viewBox="0 0 24 24" stroke-width="1.5"
                                                                stroke="currentColor" class="w-6 h-6">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    d="M12 4.5v15m7.5-7.5h-15" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div> -->

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                    <!-- end chat input section -->
                </div>
                <!-- end chat conversation section -->
            </div>
            <!-- end user chat content -->
        </div>

        <!-- VoiceMode Page -->
        <div
            :style="this.isVoiceMode == true ? 'margin: 0;padding: 0;height: 100%;width: 100%;display: flex;justify-content: center;align-items: center; position: absolute;background-color: #212529;z-index: 99 !important;' : 'margin: 0;padding: 0;height: 100%;width: 100%;display: none;justify-content: center;align-items: center; position: absolute;background-color: #212529;'">
            <div :style="voiceState == 0 || voiceState == 3 ? 'display:block;margin-top:-20px' : 'display:none'"
                id="circle-container">
                <div id="progress-ring">
                </div>
                <div id="circle">
                </div>

            </div>

            <div :style="voiceState == 1 ? 'display:block' : 'display:none'" class="voiceLoading"></div>
            <div :style="voiceState == 2 ? 'display:flex' : 'display:none'" class="bar-container">

                <div class="bar" id="bar1"></div>
                <div class="bar" id="bar2"></div>
                <div class="bar" id="bar3"></div>
                <div class="bar" id="bar4"></div>
            </div>

            <div
                :style="isMobile == true ? 'position: fixed;bottom: 0;left: 0;width: 100%;padding: 20px 30px;justify-content: space-between;align-items: center;' : 'position: fixed;bottom: 0;width: 30vw;padding: 20px 30px;justify-content: space-between;align-items: center;'">
                <div style="margin-bottom: 7vh;text-align: center">
                    <p style="color: white;font-size: 17px">{{ voiceText }}</p>
                </div>
                <div style="display: flex;align-items: end; /* Center items vertically */">
                    <button @click="closeVoiceMode()" class="btn btn-danger btn-lg chat-send"
                        style="border-radius: 50%;width: 60px;height:60px;">
                        <i class="fa-solid fa-x" style="margin-top:5px;font-weight: bold;font-size: x-large;"></i>
                    </button>
                    <div
                        :style="voiceState == 0 ? 'flex-grow: 1;display: flex;align-items: end; justify-content: center; height: 100%;margin-bottom: 5px; ' : 'flex-grow: 1;display: none;align-items: end; justify-content: center; height: 100%;margin-bottom: 5px;'">

                        <div class=" voice-bar-container">

                            <div class="voice-bar" id="bar5"></div>
                            <div class="voice-bar" id="bar6"></div>
                            <div class="voice-bar" id="bar7"></div>
                            <div class="voice-bar" id="bar8"></div>
                        </div>
                        <i style="color: white;font-size:23px;margin-right:10px" class="fa-solid fa-microphone"></i>
                    </div>
                    <div
                        :style="voiceState != 0 ? 'flex-grow: 1;display: flex;align-items: end; justify-content: center; height: 100%;margin-bottom: 5px; ' : 'flex-grow: 1;display: none;align-items: end; justify-content: center; height: 100%;margin-bottom: 5px;'">
                        <i style="color: grey;font-size:27px;margin-right:10px"
                            class="fa-solid fa-microphone-slash"></i>
                    </div>


                    <button v-if="voiceState == 0" @click="pauseVoiceMode()" class="btn btn-primary btn-lg chat-send"
                        style="border-radius: 50%;width: 60px;height:60px;">
                        <i class="fa-solid fa-pause" style="margin-top:5px;font-weight: bold;font-size: x-large;"></i>
                    </button>
                    <button v-if="voiceState == 1 || voiceState == 2" @click="stopConversation()"
                        class="btn btn-primary btn-lg chat-send" style="border-radius: 50%;width: 60px;height:60px;">
                        <i class="fa-solid fa-stop" style="margin-top:5px;font-weight: bold;font-size: x-large;"></i>
                    </button>
                    <button v-if="voiceState == 3" @click="startVoiceMode()" class="btn btn-primary btn-lg chat-send"
                        style="border-radius: 50%;width: 60px;height:60px;">
                        <i class="fa-solid fa-play" style="margin-top:5px;font-weight: bold;font-size: x-large;"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- End User chat -->
        <div v-if="isModalQuestion" class="login-box">
            <div class="basket">
                <div class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
                    <h5 class="mb-4 title fw-bold pt-2">دسته بندی ها</h5>
                    <div style="margin-top:5px" class="d-flex justify-content-between">
                        <button @click="categorys(1)" type="submit"
                            class="text-white btn btn-primary w-100">موزیک</button>

                        <button @click="categorys(2)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-right:10px">سلامتی</button>
                    </div>
                    <div style="margin-top:5px" class="d-flex justify-content-between">
                        <button @click="categorys(3)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-top:5px">مارکتینگ</button>

                        <button @click="categorys(4)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-right:10px;margin-top:5px">آشپزی</button>
                    </div>
                    <div style="margin-top:5px" class="d-flex justify-content-between">
                        <button @click="categorys(5)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-top:5px">Chat GPT</button>

                        <button @click="categorys(6)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-right:10px;margin-top:5px">محتوا</button>
                    </div>
                    <div style="margin-top:5px" class="d-flex justify-content-between">
                        <button @click="categorys(7)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-top:5px">کسب و کار</button>

                        <button @click="categorys(8)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-right:10px;margin-top:5px">آموزش</button>
                    </div>
                    <div style="margin-top:5px" class="d-flex justify-content-between">
                        <button @click="categorys(9)" type="submit" class="text-white btn btn-primary w-100"
                            style="margin-top:5px">برنامه نویسی</button>
                    </div>
                    <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">
                        <button @click="this.isModalQuestion = false" type="submit"
                            class="text-white btn btn-danger w-100">بستن</button>
                    </div>


                </div><!----><!---->
            </div>
        </div>
        <div v-if="isModalCategory" class="login-box">
            <div class="basket">
                <div style="overflow: auto;
    max-height: 70vh;" class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
                    <h5 class="mb-4 title fw-bold pt-2">{{ this.category }}</h5>
                    <div class="d-flex flex-column" v-for="(item, index) in texts" :key="index">
                        <a @click="textToChatBox(item)" type="submit" style="margin-bottom: 7px; text-align:start"
                            class="text-white btn btn-info btn-sm w-100">{{ item }}</a>
                    </div>


                </div>
                <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">
                    <button @click="this.isModalCategory = false" type="submit"
                        class="text-white btn btn-danger w-100">بستن</button>
                </div><!----><!---->
            </div>
        </div>
        <div v-if="isModalNewUser" class="login-box">
            <div class="basket">
                <div class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
                    <h5 class="mb-4 title fw-bold pt-2">تبریک!</h5>
                    <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 pb-4 text">به شما 15 کوکی 🍪 برای 7 روز داده شد.</p>
                    <button @click="closeModalNewUser()" type="submit"
                        class="text-white btn btn-primary pt-3 pb-3 ps-4 pe-4"
                        style="margin-bottom:10px;right:33%;position: relative">مرسی</button>
                </div><!----><!---->
            </div>
        </div>

        <div v-if="isModalVisible" class="login-box">
            <div class="basket">
                <div :class="this.kharid == 0 ? 'purchaseSuccess' : 'purchaseFail'"
                    class=" mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
                    <h5 class="mb-4 title fw-bold pt-2">{{ this.kharid == 0 ? 'خرید انجام شد!' : 'خرید انجام نشد!'
                        }}
                    </h5>
                    <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 pb-4 text">کاربر گرامی <br>{{ this.kharidText }}</p>
                    <button @click="closeModal()" type="submit" class="text-white btn btn-primary pt-3 pb-3 ps-4 pe-4"
                        style="margin-bottom:10px;right:35%;position: relative">بستن</button>
                </div><!----><!---->
            </div>
        </div>
        <div v-if="this.showImage == true" class="modal">

            <!-- The Close Button -->
            <span class="close" @click="this.showImage = false">&times;</span>

            <!-- Modal Content (The Image) -->
            <img :src="this.imageSource" class="modal-content" id="img01">
            <a v-if="!this.isApplication" style="margin: auto;
      display: block;
      width: 90%;
      max-width: 512px;margin-top:5px" :href="this.imageSource" download rel="noopener noreferrer" target="_blank"
                type="submit" class="text-white btn btn-info btn-md">دانلود</a>
            <a v-else style="margin: auto;
      display: block;
      width: 90%;
      max-width: 512px;margin-top:5px" :name="this.imageSource" onclick="Android.Download(this.name)"
                class="text-white btn btn-info btn-md">دانلود</a>

            
            <div id="caption"></div>
        </div>
      <!--   <div v-if="isModalKharid" class="login-box">
      <div style="padding:5px;margin-top: 15px;display: grid;">
       <span style="font-size:18px;font-weight: bold;color:white"><i class="fa-solid fa-info-circle"
            style="font-size:18px;color:#6153cc"></i> 🚀 دسترسی فقط برای کاربران ویژه        </span>
        <span style="padding:5px;margin-top:5px;font-size:13px;color:white">در حال حاضر به دلیل محدودیت‌های زیرساختی، استفاده از روبو فقط با بسته فعال امکان‌پذیر است.</span> 
        <span style="padding:5px;margin-top:5px;font-size:13px;color:white">⚡ کاربران دارای اعتبار:
- پاسخ سریع‌تر
- دسترسی پایدار
- بدون محدودیت</span> 
<span style="padding:5px;margin-top:5px;font-size:13px;color:white">💙 خدمات رایگان به‌زودی برمی‌گردد.</span> 

        <span style="font-size:18px;font-weight: bold;color:white"><i class="fa-solid fa-info-circle"
            style="font-size:18px;color:#6153cc"></i> عدم پایداری زیرساخت اینترنتی </span>
        <span style="padding:5px;margin-top:5px;font-size:13px;color:white">متاسفانه به علت عدم پایداری زیرساخت اینترنتی کشور برای خدمت‌رسانی به تمام کاربران. موقتا روبو تنها برای کاربرهای دارای بسته‌ کوکی(اعتبار) فعال است. در تلاش برای راه‌اندازی مجدد خدمات رایگان هستیم.</span>
       <div 
          style="display: flex;justify-content: end;margin-top: 10px;margin-bottom: 10px;text-align: center;">
          <div @click="gotoPackages()"
            style="margin-left:10px;padding:10px;border-radius: 5px;background-color: rgb(226, 62, 87);color:white;font-weight: bold;font-size:12px">
           فعالسازی دسترسی</div>
          <div @click="this.isModalKharid = false"
            style="padding:10px;border-radius: 5px;background-color: #6153cc;width:90px;color:white;font-weight: bold;font-size:12px">
           بعدا</div>
        </div>
      </div>
    </div> -->
    
        <PaywallABTest
            :isVisible="isModalKharid"
            :userCredit="userInfo.credit"
            :totalCookies="5"
            triggerSource="Chat"
            @close="isModalKharid = false"
            @activate="handlePaywallActivate"
        /> 
        
<ModelSelectModal
  v-if="isModalVersion"
  :modelGroups="modelGroups"
  @select="onModelSelect"
  @close="isModalVersion = false"
/>

<CharacterSelectModal
  v-if="isCharacterModalVisible"
  @select="selectCharacter"
  @close="closeCharacterModal"
/>



    </div>
</template>

<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
import markdown from 'markdown-it';
import markdownItLatex from 'markdown-it-texmath'
import katex from 'katex'
import ModelSelectModal from '@/components/ModelSelectModal.vue';
import CharacterSelectModal from '@/components/CharacterSelectModal.vue';
import PaywallABTest from '@/components/PaywallABTest.vue';
import { useShepherd } from 'vue-shepherd'

let barValues = [];
let animationFrameId = null;
let isAnimating = false;

function generateSmoothRandomValue(prev, maxChange = 2, max = 40) {
    const delta = (Math.random() - 0.5) * maxChange * 2;
    let newVal = prev + delta;
    return Math.max(0, Math.min(max, newVal));
}

function animateVisualization() {
    if (!isAnimating) return;

    barValues = barValues.map(val => generateSmoothRandomValue(val));
    const bars = [
                document.getElementById('bar5'),
                document.getElementById('bar6'),
                document.getElementById('bar7'),
                document.getElementById('bar8')
            ];
            const circle = document.getElementById('circle-container');

    // Update bars
    barValues.forEach((value, index) => {
        bars[index].style.height = `${Math.max(5, value)}px`;
    });

    // Scale the circle
    const average = barValues.reduce((a, b) => a + b, 0) / barValues.length;
    const scale = Math.min(2, 1 + average / 128);
    circle.style.transform = `scale(${scale})`;

    animationFrameId = requestAnimationFrame(animateVisualization);
}

// Call this to start
function startVisualization() {
    if (isAnimating) return;
    const bars = [
                document.getElementById('bar5'),
                document.getElementById('bar6'),
                document.getElementById('bar7'),
                document.getElementById('bar8')
            ];
            const circle = document.getElementById('circle-container');
    barValues = new Array(bars.length).fill(0);
    isAnimating = true;
    animateVisualization();
}

// Call this to stop
function stopVisualization() {
    isAnimating = false;
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
}


const tour = useShepherd({
    useModalOverlay: true,
    
  });

var md = new markdown();
md.use(markdownItLatex, {
    engine: katex,
    delimiters: 'brackets',
    katexOptions: { output: "mathml" }
});
var Emitter = require('tiny-emitter');
var emitter = new Emitter();
export default {
    head: {
    },
    components: {
        PaywallABTest,
  ModelSelectModal,
  CharacterSelectModal,
},
    name: '',
    props: {
        msg: String
    },
    data() {
        return {
            isModalVersion: false,
            aiCodeVersion: 999,
            showToolsMenu: false,
            showScrollToBottom:false,
            memoryUpdateSent: false,
        selectedTools: [],
        toolsList: [
            { value: 'reason', label: 'تفکر بیشتر', icon: 'fa-solid fa-lightbulb-on' },
            { value: 'search', label: 'جستجو در اینترنت', icon: 'fa-solid fa-globe' },
            { value: 'imagegen', label: 'ساخت تصویر', icon: 'fa-solid fa-image' },
            { value: 'imageedit', label: 'ادیت تصویر', icon: 'fa-solid fa-images' },
            { value: 'videogen', label: 'ساخت ویدیو', icon: 'fa-solid fa-video' },

            //{ value: 'deep-research', label: 'کاوش عمیق', icon: 'fa-solid fa-microscope' },
            // Add more tools here as needed
        ],
            aiVersion: 'روبو',
            conversationId: '',
            iconofchat: 'https://roboo.ir/wp-content/uploads/2023/05/botNormal.png',
            nameofchat: 'روبو',
            name: '',
            mobile: '',
            kharidText: 'خرید شما با موفقیت انجام شد.',
            credit: 0,
            chatbox: '',
            kharid: 0,
            adShowing: false,
            category: 'موزیک',
            voiceText: "در حال گوش کردن",
            isModalNewUser: false,
            isModalReferral: false,
            isModalQuestion: false,
            invites: [],
            mediaRecorder: null,
            chunks: [],
            imageSource: "",
            recognition: null,
            voiceRecognition: null,
            Referral: '',
            timerRecorder: null,
            engheza: '1402-01-01',
            character: 'chat',
            isSideBarOpen: false,
            controller: null,
            roboStatus: "فکر کردن",
            audioPlayer: null,
            texts: [],
            lastMessage: '',
            file: null,
            showImage: false,
            isModalCategory: false,
            isModalVisible: false,
            isModalKharid: false,
            isCharacterModalVisible: false,
            startRecordTime: null,
            streamRecord: null,
            fileBase64: "",
            pdfName: "",
            showContinue: false,
            isVoiceMode: false,
            imageUrl: "",
            imageFileBase64: null,
            voiceState: 0,
            javascriptNode: null,
            closingVoice: false,
            isStopVoice: false,
            welcomechat: '',
            isModelImage: true,
            isTouching: false,
            modelGroups : [
            {
    company: "روبو",
    models: [
      { id: 999,  name: "روبو",         cost: 1,  image: true, description: "انتخاب هوشمند مدل بر اساس استفاده و نیاز" },
    ]
  },
  {
    company: "OpenAI",
    models: [
      { id: 0,  name: "GPT 3.5",         cost: 1,  image: false, description: "پاسخ‌دهی سریع و اقتصادی برای مکالمات روزمره." },
      { id: 1,  name: "GPT 4",           cost: 15, image: false, description: "دقت و درک بالاتر برای مکالمات پیچیده‌تر." },
      { id: 2,  name: "GPT 4 Turbo",     cost: 10, image: true,  description: "ترکیب سرعت بالا و پشتیبانی از تصویر با هزینه کمتر." },
      { id: 10, name: "GPT 4o",          cost: 10, image: true,  description: "پشتیبانی همزمان از متن و تصویر، مناسب کاربردهای ترکیبی." },
      { id: 11, name: "GPT 4o-mini",     cost: 1,  image: true,  description: "نسخه سبک و سریع GPT-4o برای پردازش تصویر و متن." },
      { id: 12, name: "GPT o1",          cost: 20, image: true,  description: "جدیدترین مدل OpenAI با خلاقیت و کیفیت بالاتر." },
      { id: 13, name: "GPT o1-mini",     cost: 10, image: false, description: "نسخه کوچک‌تر o1 با سرعت و هزینه کمتر." },
      { id: 17, name: "GPT o3",          cost: 15,  image: true,  description: "تعادل بین سرعت و دقت، مناسب استفاده عمومی." },
      { id: 21, name: "GPT o3-mini",     cost: 5,  image: false, description: "نسخه کوچک‌تر o3 برای مکالمات سریع‌تر." },
      { id: 22, name: "GPT o4-mini",     cost: 3, image: true,  description: "نسخه سبک‌تر o4 با پشتیبانی از تصویر." },
      { id: 23, name: "GPT 4.1",         cost: 5, image: true,  description: "مدل جدید با بهبود سرعت و دقت، پشتیبانی از تصویر." },
      { id: 24, name: "GPT 4.1-mini",    cost: 2, image: true,  description: "نسخه کوچک‌تر 4.1 برای پردازش سریع‌تر." },
      { id: 25, name: "GPT 4.1-nano",    cost: 1, image: true,  description: "کوچک‌ترین نسخه 4.1 برای مصرف کم منابع." },
      { id: 31, name: "GPT 5",    cost: 5, image: true,  description: "مدل جدید با درک و استدلال" },
      { id: 32, name: "GPT 5-mini",    cost: 3, image: true,  description: "نسخه کوچک‌تر 5 برای پردازش سریع‌تر." },
      { id: 33, name: "GPT 5-nano",    cost: 2, image: true,  description: "کوچک‌ترین نسخه 5 برای مصرف کم منابع." },
      { id: 34, name: "GPT 5.1",    cost: 5, image: true,  description: "مدل جدید با درک و استدلال" },
      { id: 37, name: "GPT 5.2",    cost: 10, image: true,  description: "اخرین و قویترین نسخه با درک و استدلال" },
    ]
  },
  {
    company: "Anthropic (Claude)",
    models: [
      { id: 3,  name: "Claude 3 Haiku",    cost: 5,  image: false, description: "پاسخ‌های خلاقانه و ادبی، مناسب متن‌های خاص." },
      { id: 4,  name: "Claude 3 Sonnet",   cost: 10, image: false, description: "تولید شعر و متون ادبی با کیفیت بالاتر." },
      { id: 5,  name: "Claude 3 Opus",     cost: 15, image: false, description: "پاسخ‌های طولانی و خلاقانه برای کاربردهای خاص." },
      { id: 14, name: "Claude 3.5 Sonnet", cost: 20, image: true, description: "کیفیت بالاتر در تولید متون ادبی و خلاقانه." },
      { id: 26, name: "Claude 3.7 Sonnet", cost: 20, image: true, description: "نسخه بهبود یافته برای ادبیات و شعر." },
      { id: 27, name: "Claude 4 Sonnet",   cost: 25, image: true, description: "جدیدترین مدل برای متون ادبی با کیفیت عالی." },
      { id: 28, name: "Claude 4 Opus",     cost: 30, image: true, description: "پاسخ‌های خلاقانه و طولانی با دقت بالا." },
      { id: 40, name: "Claude 4.5 Sonnet",   cost: 25, image: true, description: "جدیدترین مدل برای متون ادبی با کیفیت عالی." },
      { id: 41, name: "Claude 4.5 Opus",     cost: 35, image: true, description: "پاسخ‌های خلاقانه و طولانی با دقت بالا." },
      { id: 42, name: "Claude 4.6 Opus",     cost: 40, image: true, description: "پاسخ‌های خلاقانه و طولانی با دقت بالا." },

    ]
  },
  {
    company: "Google (Gemini)",
    models: [
      { id: 6,  name: "Gemini Pro",        cost: 5,  image: false, description: "تحلیل زبان طبیعی با دقت و سرعت مناسب." },
      { id: 7,  name: "Gemini 1.5 Pro",    cost: 10, image: false, description: "نسخه پیشرفته‌تر با قدرت پردازش بالاتر." },
      { id: 18, name: "Gemini 2 Flash",    cost: 3,  image: true, description: "پاسخ‌دهی بسیار سریع و اقتصادی." },
      { id: 29, name: "Gemini 2.5 Flash",  cost: 5,  image: true, description: "نسخه سریع‌تر و بهینه‌تر برای مکالمات روزمره." },
      { id: 30, name: "Gemini 2.5 Pro",    cost: 10,  image: true, description: "پاسخ‌های سریع و دقیق با هزینه کم." },
      { id: 43, name: "Gemini 3 Pro",    cost: 15,  image: true, description: "اخرین و قویترین نسخه با درک و استدلال" },
    ]
  },
  {
    company: "Deepseek",
    models: [
      { id: 15, name: "Deepseek V3",       cost: 2,  image: true, description: "جستجوی عمیق و تحلیل داده‌ها با هزینه پایین." },
      { id: 16, name: "Deepseek Reasoner", cost: 5,  image: true, description: "تحلیل و استدلال پیشرفته برای سوالات پیچیده." },
    ]
  },
  {
    company: "Mistral",
    models: [
      { id: 19, name: "Mistral Large",     cost: 5,  image: false, description: "دقت بالا در درک و تولید زبان طبیعی." },
    ]
  },
  {
    company: "Perplexity",
    models: [
      { id: 9,  name: "Perplexity",        cost: 3,  image: false, description: "پاسخ‌های مختصر و دقیق برای سوالات کوتاه." },
    ]
  },
  {
    company: "Grok",
    models: [
      { id: 20, name: "Grok 2",            cost: 2,  image: false, description: "تحلیل ساختاری و معنایی پیشرفته." },
      { id: 44, name: "Grok 3",            cost: 5,  image: true, description: "تحلیل ساختاری و معنایی پیشرفته." },
      { id: 45, name: "Grok 4.1",            cost: 10,  image: true, description: "تحلیل ساختاری و معنایی پیشرفته." },
    ]
  },
  {
    company: "Cohere",
    models: [
      { id: 8,  name: "Command R Plus",    cost: 3,  image: false, description: "پاسخ فوری و عملکرد سریع برای مکالمات روزمره." },
    ]
  },
],
            isNewUpdate: navigator.userAgent.match(/NewUpdate6/i) ? true : false,
            isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
            isMobile: navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i) ? true : false,
            istyping: false,
            isMicrophoneAccess: false,
            chats: [

            ],
            history: [],
            suggestions:[],
            chatSearch:false,
            chatReason: false,
            chatResearch: false,
        }
    },
    methods: {
        
        toggleToolsMenu() {
        this.showToolsMenu = !this.showToolsMenu;
    },
    updateUserMemory(userMessage) {
        const json = {
            token: localStorage.getItem("token"),
            text: userMessage
        };
        
        axios.post("https://api.roboo.ir/api/usermemory/UpdateMemory", json)
            .then(response => {
                if (response.data === true) {
                    // Mark the current assistant message as memory updated
                    const currentMessageIndex = this.chats.length - 1;
                    if (currentMessageIndex >= 0 && this.chats[currentMessageIndex].role === 'assistant') {
                        this.chats[currentMessageIndex].memoryUpdated = true;
                    }
                }
            })
            .catch(error => {
                console.error('Memory update failed:', error);
            });
    },
    openMemoryManagement() {
        // Dispatch custom event to open memory modal
        window.dispatchEvent(new CustomEvent('openMemoryManagement'));
    },
    selectTool(tool) {
    if(tool.value == "imagegen")
    {
        router.push("/imagegeneration");
    }
    else if(tool.value == "imageedit")
    {
        router.push("/editImage");
    }
    else if(tool.value == "videogen")
    {
        router.push("/videogeneration");
    }
    // Only allow one selected tool at a time
    this.selectedTools = [tool];
    this.showToolsMenu = false;
    // Optionally, update chatReason/chatSearch here if needed:
    this.chatReason = tool.value === 'reason';
    this.chatSearch = tool.value === 'search';
    this.chatResearch = tool.value === 'deep-research';
},
removeTool(value) {
    this.selectedTools = [];
    if (value === 'reason') this.chatReason = false;
    if (value === 'search') this.chatSearch = false;
    if (value === 'deep-research') this.chatResearch = false;
},
    openMenu() {
        // Implement your menu logic here (e.g., open a sidebar or modal)
        this.$emit('openMenu');
    },
        onModelSelect(model) {
    this.selectVersion(model);
    this.isModalVersion = false;
  },
        getTextAlign(text) {
            let char = new RegExp("[\u0600-\u06FF]");
            if (text != "") {
                if (char.test(text) === true) {
                    return "right";
                }
            }
            return "left";
    },
        gheyrefaal() {
            notify({
                title: "پیام",
                text: "در حال حاضر غیر فعال است.",
                type: "info"
            });
        },
        onTakePicture(e) {
            this.imageUrl = "";
            this.isSideBarOpen = false;
            var imageFile = null;
            if (e.target.files.length > 0) {
                imageFile = e.target.files[0];
                var filesize = ((imageFile.size/1024)/1024).toFixed(4); // MB
                if(filesize > 10)
                {
                notify({
                                title: "خطا",
                                text: "حجم عکس از 10 مگابایت بیشتر است.\nلطفا حجم را کاهش دهید.",
                                type: "error"
                            });
                            return;
                }
                this.imageUrl = require('../assets/loading.png')
                var that = this;
                var fileReader = new FileReader();
                var base64;
                // Onload of file read the file content
                fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    // Print data in console
                    base64 = base64.split(',')[1];
                    let json = {
                        fileBase64: base64
                    }
                    axios.post("https://api.roboo.ir/api/chat/CreateImageAnswering", json).then((response) => {
                        if (response.data.status == 0) {

                            that.imageUrl = "https://api.roboo.ir/content/ImageAnswering/" + response.data.message;
                        }
                        else {
                            that.imageUrl = "";
                            notify({
                                title: "خطا",
                                text: "در هنگام آپلود مشکلی پیش آمده است مجدد تلاش کنید",
                                type: "error"
                            });
                        }
                    });
                };
                // Convert data to base64
                fileReader.readAsDataURL(imageFile);
            }
        },
        onFileUploadImage(e) {
            this.imageUrl = "";
            this.isSideBarOpen = false;
            var imageFile = null;
            if (e.target.files.length > 0) {
                imageFile = e.target.files[0];
                var filesize = ((imageFile.size/1024)/1024).toFixed(4); // MB
                if(filesize > 10)
                {
                notify({
                                title: "خطا",
                                text: "حجم عکس از 10 مگابایت بیشتر است.\nلطفا حجم را کاهش دهید.",
                                type: "error"
                            });
                            return;
                }
                this.imageUrl = require('../assets/loading.png')
                var that = this;
                var fileReader = new FileReader();
                var base64;
                // Onload of file read the file content
                fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    // Print data in console
                    base64 = base64.split(',')[1];
                    let json = {
                        fileBase64: base64
                    }
                    axios.post("https://api.roboo.ir/api/chat/CreateImageAnswering", json).then((response) => {
                        if (response.data.status == 0) {
                            that.imageUrl = "https://api.roboo.ir/content/ImageAnswering/" + response.data.message;
                        }
                        else {
                            that.imageUrl = "";
                            notify({
                                title: "خطا",
                                text: "در هنگام آپلود مشکلی پیش آمده است مجدد تلاش کنید",
                                type: "error"
                            });
                        }
                    });
                };
                // Convert data to base64
                fileReader.readAsDataURL(imageFile);
            }
        },
        removeImage() {
            this.imageUrl = "";
        },
        removePdf() {
            this.pdfName = "";
            this.file = null;
            this.fileBase64 = "";
        },
        showBezodi() {
            notify({
                title: "روبو",
                text: "بزودی این قابلیت اضافه میشود. میتوانید از روبو ویژن استفاده کنید.",
                type: "info"
            });
        },
        onFileUpload(e) {


            this.imageUrl = "";
            this.file = null;
            if (e.target.files.length > 0) {
                this.file = e.target.files[0];
                var file = e.target.files[0];
                this.pdfName = e.target.files[0].name;
                var that = this;
                var fileReader = new FileReader();
                var base64;
                // Onload of file read the file content
                fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    // Print data in console
                    base64 = base64.split(',')[1];
                    that.fileBase64 = base64;
                };
                // Convert data to base64
                fileReader.readAsDataURL(file);
            }
            const floatingBtn = document.querySelector(".floating-btn");
            floatingBtn.classList.remove("active");
        },
        selectVersion(model) {
            this.isModalVersion = false;
            this.aiCodeVersion = model.id;
            this.aiVersion = model.name;
            this.isModelImage = model.image
        },
        showVoice() {
            if (this.isApplication == true && this.isNewUpdate == false) {
                notify({
                    title: "روبو",
                    text: "برای استفاده از این قابلیت نسخه جدید روبو را نصب کنید.",
                    type: "info"
                });
                return;
            }
            this.isVoiceMode = true;
            setTimeout(() => {
                this.startVoiceMode();
            }, 200);
        },
        closeVoiceMode() {
            this.isVoiceMode = false;

           // this.javascriptNode.disconnect();
            var that = this;
            setTimeout(() => {
                that.voiceRecognition.stop()

                

            }, 50);
            if (this.audioPlayer.paused == false) {
                this.audioPlayer.pause();
            }
            clearInterval(this.timerRecorder);
            this.voiceState = 0;
        },
        pauseVoiceMode() {
            //this.javascriptNode.disconnect();
            this.voiceState = 3;
            this.voiceText = "برای صحبت دکمه را بزنید";
            stopVisualization();
            var that = this;
            that.voiceRecognition.stop()
            

        },
        stopChat() {
            if (this.istyping == true && this.chats[this.chats.length - 1].role != "user") {
                this.controller.abort();
                this.istyping = false;
            }
            else {
                notify({
                    title: "روبو",
                    text: "صبر کنید پاسخی دریافت شود!",
                    type: "info"
                });
            }
        },
        stopConversation() {
            this.isStopVoice = true;
            if (this.voiceState == 2) {
                this.audioPlayer.pause();
            }
            if (this.istyping == true) {
                this.controller.abort();
                this.istyping = false;
            }
            this.startVoiceMode();

        },
        startVoiceMode() {
            if (this.isApplication) {
                Android.CheckMicrophone();
            }
            if (this.userInfo.credit <= 0) {
                this.isModalKharid = true;
                return;
            }
            if(this.voiceRecognition == null){
            //this.chunks = [];
            window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.voiceRecognition = new SpeechRecognition();

var selectedValue = 'fa-IR';
this.voiceRecognition.lang = selectedValue;
//this.voiceRecognition.continuous = true;

            }


            this.voiceState = 0;
            this.voiceText = "در حال گوش کردن";
            if (this.isVoiceMode == false)
                return;
            var that = this;
            var isSilence = false;
            var startedTalking = false;

            this.chunks = [];

            // const bars = [
            //     document.getElementById('bar5'),
            //     document.getElementById('bar6'),
            //     document.getElementById('bar7'),
            //     document.getElementById('bar8')
            // ];
            // const circle = document.getElementById('circle-container');

            that.voiceRecognition.continuous = false;
            that.voiceRecognition.onresult = function(event) {
                
                if(that.voiceState > 1 || that.isVoiceMode == false)
                return;

                if(that.isTouching == false)
                that.endTalking();

  const transcript = event.results[0][0].transcript;
  that.chatbox += transcript + " ";
                                            
                                            
                                            if(that.isTouching == false)
                                            {
                                            that.checkConvThenPost();
                                            }
}
startVisualization(); // Starts animation
            that.voiceRecognition.start();

            /*
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(stream => {
                    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    const analyser = audioContext.createAnalyser();
                    const microphone = audioContext.createMediaStreamSource(stream);
                    const javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);
                    that.javascriptNode = javascriptNode;
                    analyser.smoothingTimeConstant = 0.8;
                    analyser.fftSize = 1024;

                    microphone.connect(analyser);
                    analyser.connect(javascriptNode);
                    javascriptNode.connect(audioContext.destination);

                    javascriptNode.onaudioprocess = () => {
                        const array = new Uint8Array(analyser.frequencyBinCount);
                        analyser.getByteFrequencyData(array);

                        let values = 0;
                        const length = array.length;
                        for (let i = 0; i < length; i++) {
                            values += array[i];
                        }

                        const average = values / length;
                        if (average > 3.0 && startedTalking == false) {
                            startedTalking = true;
                            this.startRecordTime = new Date();
                            that.voiceRecognition.start();
                            that.isStopVoice = false;

                            setTimeout(() => {
                                if (that.voiceState == 0) {
                                    that.voiceText = "برای کنترل دستی، دایره را نگه دارید";
                                    setTimeout(() => {
                                        if (that.voiceState == 0) {
                                            that.voiceText = "در حال گوش کردن";
                                        }
                                    }, 3000);
                                }
                            }, 2000);
                        }
                        if (startedTalking == true) {
                            if (average < 3.0 && isSilence == false) {
                                isSilence = true;
                                that.timerRecorder = setTimeout(() => {
                                    console.log("Started");
                                    if (that.voiceState == 3)
                                        return;
                                    clearInterval(that.timerRecorder);
                                    that.endTalking();
                                    microphone.disconnect()
                                    analyser.disconnect()
                                    javascriptNode.disconnect()

                                }, 1500)
                            }
                            if (average > 3.0 && isSilence == true) {
                                clearInterval(that.timerRecorder);
                                isSilence = false;
                            }
                        }
                        setTimeout(() => {
                            // Adjust the number of bars and how they react to the frequency data
                            bars.forEach((bar, index) => {


                                var barHeight = array[index] / 4; // Scale the height
                                if (barHeight > 40.0)
                                    barHeight = 40.0;
                                if (barHeight <= 0.0)
                                    bar.style.height = `5px`;
                                else
                                    bar.style.height = `${barHeight}px`;
                            });
                        }, 100);
                        // Scale the circle based on average audio volume
                        const scale = Math.min(2, 1 + average / 128);
                        circle.style.transform = `scale(${scale})`;
                        //console.log(average);
                    };
                    that.voiceRecognition.onresult = function(event) {
  const transcript = event.results[0][0].transcript;
                                        if (that.isStopVoice == true || that.voiceState == 0)
                                            return;
                                            that.chatbox += transcript;
                                            that.checkConvThenPost();
}
                    //Gathering Audio
                     that.streamRecord = stream;
                    // console.log("Started Streaming");
                    // that.mediaRecorder = new MediaRecorder(stream,
                    //     {
                    //         audioBitsPerSecond: 16000,
                    //     })
                    // that.mediaRecorder.ondataavailable = (e) => {
                    //     that.chunks.push(e.data);
                    // };
                    // that.mediaRecorder.onstop = (e) => {
                    //     console.log("Stopped");
                    //     if (that.isVoiceMode == false && that.voiceState == 3)
                    //         return;
                    //     const blob = new Blob(this.chunks, { type: "audio/ogg; codecs=opus" });
                    //     var reader = new window.FileReader();
                    //     reader.readAsDataURL(blob);
                    //     reader.onloadend = function () {
                    //         var base64 = reader.result;
                    //         base64 = base64.split(',')[1];
                    //         let json = {
                    //             fileBase64: base64
                    //         }
                            // axios.post("https://api.roboo.ir/api/chat/senddata", json).then((response) => {
                            //     if (response.data.status == 0) {
                            //         if (response.data.message == "PYM JBZ") {
                            //             notify({
                            //                 title: "خطا",
                            //                 text: "ویس خالی است.",
                            //                 type: "error"
                            //             });
                            //             that.startVoiceMode();
                            //         }
                            //         else {
                            //             if (that.isStopVoice == true || that.voiceState == 0)
                            //                 return;
                            //             that.chatbox = response.data.message;
                            //             that.checkConvThenPost();

                            //         }
                            //     }
                            //     else {
                            //         notify({
                            //             title: "خطا",
                            //             text: response.data.message,
                            //             type: "error"
                            //         });
                            //     }
                            //     // icon.classList.add('fa-microphone');
                            // }).catch(() => {
                            //     // icon.classList.add('fa-microphone');
                            //     notify({
                            //         title: "خطا",
                            //         text: "هنگام ارسال درخواست مشکلی به وجود امده.\nلطفا دوباره تلاش کنید.",
                            //         type: "error"
                            //     });
                            // });
                     //   }






                 //   }

                })
                .catch(err => console.error('Error accessing the microphone: ', err));
                */
        },
        finishedChat() {
            if (this.voiceState == 3)
                return;
            var tText = this.chats[this.chats.length - 1].chat;
            let json = {
                text: tText
            }
            var that = this;
            axios.post("https://api.roboo.ir/api/audio/GetAudio", json).then(response => {
                if (response.data.status == 0) {
                    this.voiceState = 2;
                    this.voiceText = "";
                    setTimeout(() => {
                        var base64 = response.data.message;
                        this.audioPlayer = new Audio("data:audio/wav;base64," + base64);
                        const bars = [
                            document.getElementById('bar1'),
                            document.getElementById('bar2'),
                            document.getElementById('bar3'),
                            document.getElementById('bar4')
                        ];

                        // Set up the Web Audio API context
                        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                        const analyser = audioContext.createAnalyser();
                        analyser.fftSize = 256;

                        // Connect the audio source to the analyser
                        const source = audioContext.createMediaElementSource(this.audioPlayer);
                        source.connect(analyser);
                        analyser.connect(audioContext.destination);

                        // Create a buffer to hold the frequency data
                        const bufferLength = analyser.frequencyBinCount;
                        const dataArray = new Uint8Array(bufferLength);

                        function animateBars() {
                            requestAnimationFrame(animateBars);

                            // Get the frequency data
                            analyser.getByteFrequencyData(dataArray);

                            // Map the frequency data to bar heights
                            bars.forEach((bar, index) => {
                                const barHeight = dataArray[index] / 2; // Scale down the height
                                bar.style.height = `${barHeight}px`;
                            });
                        }

                        // Start the animation when the audio is played
                        this.audioPlayer.addEventListener('play', () => {
                            audioContext.resume().then(() => {
                                animateBars();
                            });
                        });
                        this.audioPlayer.play();
                        var that = this;
                        this.audioPlayer.addEventListener("ended", function () {
                            setTimeout(() => {
                                audioContext.close();
                                that.startVoiceMode();
                            }, 250);
                        });
                    }, 10);
                }

            });

        },
        endTalking() {
            if (this.userInfo.credit <= 0) {
                return;
            }
            this.voiceState = 1;
            this.voiceText = "در حال فکر کردن";
            stopVisualization();

            var that = this;

            setTimeout(() => {
                that.voiceRecognition.stop();
                
                //that.mediaRecorder.stop()


            }, 100);
            clearInterval(this.timerRecorder);
        },
        async start() {
            // eslint-disable-next-line
            if (this.isApplication) {
                Android.CheckMicrophone();
            }
            if (this.userInfo.credit <= 0) {
                this.isModalKharid = true;
                return;
            }
            var that = this;

if(this.recognition == null){
            //this.chunks = [];
            window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new SpeechRecognition();

var selectedValue = 'fa-IR';
this.recognition.lang = selectedValue;
this.recognition.continuous = true;


this.recognition.onstart = function() {
   that.startRecordTime = new Date();
            var icon = document.getElementById("voiceicon");
            if (icon.classList.contains("fa-ellipsis")) {
                return;
            }
            var button = document.getElementById("voicebutton");
            button.classList.add("rec-effect-4");
            icon.classList.remove('fa-microphone');
            icon.classList.add('fa-stop');
}


this.recognition.onresult = function(event) {
  const transcript = event.results[0][0].transcript;
    that.chatbox += transcript;
}
var button = document.getElementById("voicebutton");

this.recognition.onend = function() {
    // if(document.getElementsByClassName('rec-effect-4').length > 0)
    // that.recognition.start();
}

}
this.recognition.start();

            // navigator.mediaDevices.getUserMedia({
            //     audio: true
            // }).then(stream => {
            //     that.streamRecord = stream;
            //     console.log("Started Streaming");
            //     that.mediaRecorder = new MediaRecorder(stream,
            //         {
            //             audioBitsPerSecond: 16000,
            //         })
            //     that.mediaRecorder.ondataavailable = (e) => {
            //         that.chunks.push(e.data);

            //     };
            //     that.mediaRecorder.onstop = (e) => {
            //         const blob = new Blob(this.chunks, { type: "audio/ogg; codecs=opus" });
            //         var reader = new window.FileReader();
            //         reader.readAsDataURL(blob);
            //         reader.onloadend = function () {
            //             var base64 = reader.result;
            //             base64 = base64.split(',')[1];
            //             let json = {
            //                 fileBase64: base64
            //             }
            //             axios.post("https://api.roboo.ir/api/chat/senddata", json).then((response) => {
            //                 if (response.data.status == 0) {
            //                     if (response.data.message == "PYM JBZ") {
            //                         notify({
            //                             title: "خطا",
            //                             text: "ویس خالی است.",
            //                             type: "error"
            //                         });
            //                     }
            //                     else
            //                         that.chatbox = response.data.message;
                                
            //                 }
            //                 else {
            //                     notify({
            //                         title: "خطا",
            //                         text: response.data.message,
            //                         type: "error"
            //                     });
            //                 }
            //                 icon.classList.remove('fa-ellipsis');
            //                 icon.classList.add('fa-microphone');
            //             }).catch(() => {
            //                 icon.classList.remove('fa-ellipsis');
            //                 icon.classList.add('fa-microphone');
            //                 notify({
            //                     title: "خطا",
            //                     text: "هنگام ارسال درخواست مشکلی به وجود امده.\nلطفا دوباره تلاش کنید.",
            //                     type: "error"
            //                 });
            //             });


            //         }


            //         that.chunks = [];

            //     }
            //     that.mediaRecorder.start()

            // })
            //     .catch(err => log(err.name + ": " + err.message));

        },
        end() {
            if (this.userInfo.credit <= 0) {
                return;
            }
            var button = document.getElementById("voicebutton");
            button.classList.remove("rec-effect-4");
            var icon = document.getElementById("voiceicon");
            icon.classList.remove('fa-stop');
            var timeDiff = Math.abs(this.startRecordTime.getTime() - (new Date()).getTime());
            if (timeDiff < 1000) {
                notify({
                    title: "روبو",
                    text: "دکمه را نگه دارید.",
                    type: "info"
                });
                icon.classList.add('fa-microphone');

                return;
            }

            var that = this;
            var button = document.getElementById("voicebutton");
            button.classList.remove("rec-effect-4");
            var icon = document.getElementById("voiceicon");
            icon.classList.remove('fa-stop');
            icon.classList.add('fa-ellipsis');

            this.recognition.stop();
            clearInterval(this.timerRecorder);
        },
        showReferral() {
            this.$emit("showReferral");
        },
        showCredit() {
            this.$emit("showCredit");
        },
        handleEnter(event) {
            if (this.isMobile)
                return;
            if ((event.shiftKey && event.key === 'Enter')) {
                // Allow the default behavior of creating a new line on Android devices
                return;
            }

            event.preventDefault();
            if (this.character == 'roboimage')
                this.generateImage();
            else
                this.checkConvThenPost();
        },
        showAd() {
            notify({
                title: "روبو",
                text: "در حال اماده سازی ویدیو. لطفا منتظر بمانید!",
                type: "info"
            });
            this.isModalKharid = false;
            this.userInfo.credit = this.userInfo.credit + 3;
            this.$emit("setCredit")
            this.credit = this.credit + 3;
            try {
                Android.ShowAdAdivery('8a4d6b52-0e81-4470-8755-c1e6e08806fa', "3");
                //Android.ShowAd('64b58b3c4bf57453cab34119',"3");
            }
            catch {
                try {
                    Android.ShowAd('64b58b3c4bf57453cab34119', "3");
                }
                catch {
                    Android.ShowAd('64b58b3c4bf57453cab34119');
                }
            }
            this.chatbox = this.lastMessage;
            this.lastMessage = "";
        },
        clearChats() {

            if (this.istyping) {
                notify({
                    title: "روبو",
                    text: "در حال صحبت هستم لطفا پس از اتمام پاک کنید",
                    type: "info"
                });
                return;
            }

            //this.getuserData();


            notify({
                title: "روبو",
                text: "پاکش کردم و داخل گفتگو های قبلیت ریختمش😏",
                type: "info"
            });

        },
        copy(id) {
            let element = document.getElementById('copy' + id);
            element.classList.remove('fa-clipboard');
            element.classList.add('fa-check');

            setTimeout(() => {
                element.classList.add('fa-clipboard');
                element.classList.remove('fa-check');
            }, 1500)
            notify({
                title: "روبو",
                text: "برات کپیش کردم 🥰",
                type: "info"
            });
        },
        showCopy() {
            notify({ title: "کپی", text: "کد شما کپی شد", type: "success" });
        },
        categorys(id) {

            if (id == 1) {
                this.category = "موزیک";
                this.texts = [];
                this.texts.push("می خواهم یک موزیک ویدیو بسازم اما نمی دانم از چه مفهومی استفاده کنم. منو راهنمایی کن");
                this.texts.push("یک پشروی آکورد بلوز 12 نواری در کلید E بنویسید");
                this.texts.push("متن آهنگی با عنوان [عنوان آهنگ] را بنویس");
                this.texts.push("یک شعر یا آهنگ برای <مخاطب هدف> ایجاد کنید که <موضوع انتخلبی شما> را توضیح دهد");
                this.texts.push("پیشرفت آکورد زیر را تغییر دهید تا بیشتر شبیه <بر اساس برخی دستورات, مانند آهنگساز یا سبک> باشد");
                this.texts.push("متن شعر مرغ سحر ناله سر کن شجریان رو بنویس");
                this.texts.push("من می خواهم یک فایل midi بنویسم. میشه کد python رو بزارید");
                this.texts.push("یک آهنگ در مقیاس پنتاتونیک و 4/4 زمان برای <هنرمند مورد نظر خود> بنویس");
                this.texts.push("یک مشاعره بین حافظ و مولانا انجام بده");
                this.texts.push("پیشرفت های آکورد را برای یک آهنگ راک کانتری, با شعر,کر و بریج بنویسید");
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 2) {
                this.category = "سلامتی";
                this.texts = [];
                this.texts.push("چند راه برای پرورش ذهنیت رشد چیست؟");
                this.texts.push("4 وعده غذایی مغذی را در نظر بگیرید که می توانید در عرض نیم ساعت یا کمتر تهیه کنید");
                this.texts.push("چند تمرین ذهن آگاهی برای کاهش اضطراب چیست؟");
                this.texts.push("من به کمک نیاز دارم تا در کار با انگیزه بمانم. می توانی به من چند راهکار بدی؟");
                this.texts.push("چند تا فعالیت خود مراقبتی را برای کاهش استرس پیشنهاد بده");
                this.texts.push("یک برنامه ورزشی 30 روزه ایجاد کنید که به من کمک میکند هر هفته 2 کیلو وزن کم کنم");
                this.texts.push("8 تا ماده غذایی که ارزان باشه و به طرز شگفت انگیزی مغذی باشه رو بهم بگو");
                this.texts.push("برای <دستیابی به یک کار یا هدف خاص> به انگیزه نیاز دارم. میشه بهم انگیزه بدی");
                this.texts.push("شش حرکت کششی موثر در یوگا را برای کمردرد و گردن توضیح دهید");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 3) {
                this.category = "مارکتینگ";
                this.texts = [];
                this.texts.push("چگونه میتوانم Back link های با کیفیت برای بالا بردن SEO [نام وب سایت] به دست بیاورم؟");
                this.texts.push("یک طرح کمپین [رسانه های اجتماعی] برای راه اندازی [محصول شما] با هدف [مخاطبان هدف شما] بساز");
                this.texts.push("یک اسکریپت یک دقیقه ای برای تبلیغ درمورد (محصول یا خدمت یا شرکت) بساز");
                this.texts.push("یک پست برای انتشار در توئیتر بساز که نسل زد را هدف قرار دهد و توضیح دهد که چگونه محصول ما [نام محصول] می تواند به آنها کمک کند");
                this.texts.push("قهرستی از 5 ایده ویدیوی YouTube برای [محصول یا شرکت شما] تهیه کن");
                this.texts.push("یک خبرنامه هفتگی [موضوع خبرنامه] را بساز");
                this.texts.push("یک توضیح محصول برای [محصول یا خدمت یا شرکت] من بنویس");
                this.texts.push("یک پست اینستاگرام بساز که مزایای محصول من رو (نام محصول) پیشنهاد بده");
                this.texts.push("5 روش خلاقانه برای استفاده از حلقه های اینستاگرام برای شما ایجاد کنید");
                this.texts.push("چطور میتوانم فالور های اینستاگرام افزایش بدم");
                this.texts.push("روش های مقرون به صرفه برای تبلیغ (شرکت) خود با/بدون استفاده از (شبکه های اجتماعی) پیشنهاد بده");
                this.texts.push("برای افرادی که در وبینار {موضوع وبینار} من شرکت کرده اند ایمیل های تکمیلی بنویسید");
                this.texts.push("یک ایمیل تبریک شخصی برای یک مشتری VIP بنویس");
                this.texts.push("یه ایده هایی برای پست های ولاگ درمورد موضوع (انتخابی) نیاز دارم");
                this.texts.push("چجوری میتوانم یک استراتژی برای استوری های روزانه در اینستاگرام داشته باشم؟");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 4) {
                this.category = "آشپزی";
                this.texts = [];
                this.texts.push("یه منو باحال بهاری بگو؟");
                this.texts.push("من گیاهخوار هستم. یه ایده باحال برای شام بهم بده");
                this.texts.push("برای کسی که یه روز سخت داشته یه غذای خوب پیشنهاد بده");
                this.texts.push("من گوجه, کاهو و کلم بروکلی دارم. چه چیزی می توانم با آنها برای یک ناهار وگان آماده کنم؟");
                this.texts.push("برای یک هغته شام دو بزرگسال برنامه ریزی کن که چه غذاهایی بپزم");
                this.texts.push("سریع و آسان ترین راه برای تهیه ماکارونی با سس سفید و قارچ چیست؟");
                this.texts.push("من فقط پیاز, گوجه فرنگی و اسفناج دارم. 3 وعده غذایی را به من بگو که با این مواد درست کنم؟");
                this.texts.push("یک برنامه غذایی برای دو روز تهیه کنید و لیست خرید آن را به من بدهید");
                this.texts.push("برای نوروز ایرانی, دستور پخت غذای جذاب با ماهی بهم پیشنهاد کن");
                this.texts.push("طرز تهیه خورشت قیمه رو بگو");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 5) {
                this.category = "Chat GPT";
                this.texts = [];
                this.texts.push("آیا Chat GPT امن است؟");
                this.texts.push("Chat GPT چیست؟");
                this.texts.push("آیا Chat GPT می تواند یک مقاله بنویسد؟");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 6) {
                this.category = "محتوا";
                this.texts = [];
                this.texts.push("وبلاگ در مورد [موضوع دلخواه شما] بنویسید");
                this.texts.push("یک داستان علمی تخیلی در 200 کلمه بنویس که شخصیت اول اسمش علی باشه و میخواهد دنیا را نجات دهد");
                this.texts.push("یک مطالعه موردی با جزئیات <موضوع انتخابی> بنویسید");
                this.texts.push("یک درس درمورد منابع انرژی تجدید پذیر برای دانش آموزان دبیرستانی طراحی کن");
                this.texts.push("یک راهنمای جامع برای [موضوع] بنویسید");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 7) {
                this.category = "کسب و کار";
                this.texts = [];
                this.texts.push("چه عواملی را باید در هنگام نقل قول برای یک معامله برند در نظر بگیرم؟");
                this.texts.push("به عنوان یک صاحب کسب و کار کوچک, درمورد شبکه سازی و ایجاد مشارکت راهنماییم کن");
                this.texts.push("درباره <صنعت> و روندها, چالش ها و فرصت های آن, از جمله داده ها و آمار های مربوطه راهنماییم کن");
                this.texts.push("من باید یک ارائه برای یک سرمایه گذار بالقوه در مورد <موضوع ارائه> آماده کنم. میشه راهنماییم کنید که چی بزارم؟");
                this.texts.push("یک بررسی دقیق از <نرم افزار یا ابزار خاص> برای <تشریح کسب و کار خود> انجام بده");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 8) {
                this.category = "آموزش";
                this.texts = [];
                this.texts.push("من یه معلم هستم. یه فهرست از 10 ویژگی منحصر به فرد را برای درج در رزومه بعنوان یک معلم ریاضی بنویس");
                this.texts.push("بهترین روش آموزش کودکان چیست؟");
                this.texts.push("فهرستی از مراحل مشخص و قابل اجرا که یک دانش آموز باید انجام دهد تا بتواند عملکرد خود را در (موضوع/وظیفه) بهبود بخشد تهیه کن");
                this.texts.push("یه سوال چهار گزینه ای طرح کن که صورت سوال درباره گرم شدن کره زمین باشه");
                this.texts.push("کودکان در یادگیری حروف صدا دار چه مشکلاتی دارند؟");
                this.texts.push("یک مقاله در مورد تبعیض اجتماعی بنویس که نمره 20 بگیرم");
                this.texts.push("برای آموزش یک زبان جدید چه مراحلی باید طی شه؟");
                this.texts.push("پیشنهاد طراحی یه پوستر بده که دانش آموزان, مقررات کلاس درس و همچنین مجازات را متوجه بشوند");
                this.texts.push("فهرستی از 5 استراتژی آموزشی ایجاد کنید که می تواند برای درگیر کردن و به چالش کشیدن دانش آموزان در سطوح مختلف توانایی در یک درس در مورد [مفهوم در حال آموزش] استفاده شود.");
                this.texts.push("2 راهکار برای معلم ها که بتوانند بر یادگیری و پیشرفت دانش آموزان نظارت کنند پیشنهاد بده");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if (id == 9) {
                this.category = "برنامه نویسی";
                this.texts = [];
                this.texts.push("من می خواهم یک هدر چسبنده در وب سایت خود پیاده سازی کنم. آیا می توانید مثالی از نحوه انجام این کار با استفاده از CSS و جاوا اسکریپت ارائه دهید ؟");
                this.texts.push("نام جدول هارا فرض کنید و یک کد SQL ایجاد کنید تا توییت های ایلان ماسک در سال 2019 را داشته باشد");
                this.texts.push("یک docstring برای تابغ زیر <تابع شما> بنویسید");
                this.texts.push("اشکال کد زیر را پیدا کن: <کد>");
                this.texts.push("من درحال ساخت یک وب سایت برای یک تجارت کوچک [شرح کسب و کار]. من به ایده هایی درمورد چگونگی ساختار وب سایت نیاز دارم");
                this.texts.push("این regex دقیقا چه کاری انجام میدهد ؟ <کد شما>");
                this.texts.push("من می خواهم رندر سمت سرور را برای برنامه React خود پیاده سازی کنم. آیا میتوانید مثالی از نحوه انجام این کار با استفاده از Next.js ارائه دهید؟");
                this.texts.push("لطفا به نوشتن این کد برای جاوا اسکریپت <کد شما> ادامه دهید");
                this.texts.push("من باید یک نقطه پایانی  Rest API برای برنامه وب ایجاد کنم");
                this.texts.push("آیا میتوانید مثالی از نحوه انجام این کار با استفاده از Node.js ارائه دهید؟");
                this.texts.push("یه نکنه طراحی UX ارائه دهید تا بتوانم آن را در Linkedin به اشتراک بگذارم");
                this.texts.push("با استفاده از وردپرس فهرستی از 10 مهارت و تجربه مرتبط را برای یک برنامه شغلی توسعه دهنده وب ایجاد کنید");
                this.texts.push("یک معماری توسعه وب سایت با جاوا اسکریپت پیشنهاد بده");

                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
        },
        changeToImage() {
            if (this.character == 'roboimage') {
                this.character = 'chat';
                this.nameofchat = 'روبو'
            }
            else {
                this.character = 'roboimage';
                this.nameofchat = 'روبو پیکاسو';
            }
            //this.getuserData();
            setTimeout(() => {
                var element = document.querySelector('#scroller');
                element.scrollTop = element.scrollHeight;
            }
                , 1000)

        },

        deletes(id) {
            let id2 = id - 1;

            axios.post("https://api.roboo.ir/api/chat/Delete?Token=" + localStorage.getItem("token") + "&Id=" + id);
            this.history = this.history.filter(x => {
                return x.id != id;
            })
            this.history = this.history.filter(x => {
                return x.id != id2;
            })
            notify({
                title: "روبو",
                text: "حذف شد. کی؟ کجا؟ کدوم پیام؟ 😉 ",
                type: "info"
            });
        },

        audio(id) {
            let id2 = id;
            var tText = "";
            var doci = document.getElementById('talk' + id).getElementsByTagName('i')[0];
            if (!doci.classList.contains("fa-stop")) {
                doci.classList.remove("fa-volume-high");
                doci.classList.add("fa-stop");
                var chatt = this.chats.filter(x => {
                    return x.id == id2;
                });

                if (chatt.length > 0) {
                    tText = chatt[0].chat;
                }
                let json = {
                    text: tText
                }

                axios.post("https://api.roboo.ir/api/audio/GetAudio", json).then(response => {
                    if (response.data.status == 0) {
                        var base64 = response.data.message;
                        this.audioPlayer = new Audio("data:audio/wav;base64," + base64);
                        this.audioPlayer.play();
                        var that = this;
                        this.audioPlayer.addEventListener("ended", function () {

                            doci.classList.remove("fa-stop");
                            doci.classList.add("fa-volume-high");
                        });
                    }
                });
            }
            else {
                this.audioPlayer.pause();
                doci.classList.remove("fa-stop");
                doci.classList.add("fa-volume-high");
            }
        },
        audioHistory(id) {
            let id2 = id;
            var tText = "";
            var doci = document.getElementById('talk' + id).getElementsByTagName('i')[0];
            if (!doci.classList.contains("fa-stop")) {
                doci.classList.remove("fa-volume-high");
                doci.classList.add("fa-stop");
                var chatt = this.history.filter(x => {
                    return x.id == id2;
                });

                if (chatt.length > 0) {
                    tText = chatt[0].chat;
                }
                let json = {
                    text: tText
                }

                axios.post("https://api.roboo.ir/api/audio/GetAudio", json).then(response => {
                    if (response.data.status == 0) {
                        var base64 = response.data.message;
                        this.audioPlayer = new Audio("data:audio/wav;base64," + base64);
                        this.audioPlayer.play();
                        var that = this;
                        this.audioPlayer.addEventListener("ended", function () {

                            doci.classList.remove("fa-stop");
                            doci.classList.add("fa-volume-high");
                        });
                    }
                });
            }
            else {
                this.audioPlayer.pause();
                doci.classList.remove("fa-stop");
                doci.classList.add("fa-volume-high");
            }
        },
        like(id) {
            document.getElementById('like' + id).setAttribute("style", "background-color: #878a99;");
            let element = document.getElementById('dislike' + id);
            if (element != null)
                element.remove();
            notify({
                title: "روبو",
                text: "خیلی خوشحالم مرسی بابت فیدبکت 😍 ",
                type: "info"
            });
        },
        dislike(id) {
            document.getElementById('dislike' + id).setAttribute("style", "background-color: #878a99;");
            let element = document.getElementById('like' + id);
            if (element != null)
                element.remove();
            notify({
                title: "روبو",
                text: "مرسی بابت فیدبکت دفعه بعد بیشتر تلاش میکنم 😘",
                type: "info"
            });
        },
        checkChat(chat) {
            let char = new RegExp("[\u0600-\u06FF]");
            if (chat != "") {
                if (char.test(chat) === true) {
                    return true;
                }
                else {
                    return false;
                }
            }
        },
        closeModalNewUser() {
            this.isModalNewUser = false;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        closeCharacterModal() {
            this.isCharacterModalVisible = false;
        },
        selectCharacter(character) {
            this.setCharacter(character.id);
            this.isCharacterModalVisible = false;
        },
        gotoCharacters() {
            this.isCharacterModalVisible = true;
        },
        gotoPackages() {
            router.push('packages');
        },
        handlePaywallActivate(data) {
            this.isModalKharid = false;
            // Navigate to packages page with selected package and period
            if (data && data.package && data.period) {
                router.push({
                    path: 'packages',
                    query: {
                        package: data.package,
                        period: data.period
                    }
                });
            } else {
                router.push('packages');
            }
        },
        showPoshtibani() {

        },
        logout() {
            localStorage.setItem('token', "");
            router.push('login');
        },
        textToChatBox(matn) {
    this.isModalCategory = false;
    this.chatbox = matn;
    this.$nextTick(() => {
        const textarea = document.getElementById('textarea-input');
        if (textarea) {
            const minHeight = 43;
            textarea.style.height = 'auto';
            if (!textarea.value || textarea.value === '') {
                textarea.style.height = minHeight + 'px';
            } else {
                textarea.style.height = Math.max(textarea.scrollHeight, minHeight) + 'px';
            }
        }
    });
},











        generateImage() {
            if (this.istyping == true) {
                notify({
                    title: "روبو",
                    text: "در حال ساخت هستم لطفا منتظر بمانید",
                    type: "info"
                });
                return;
            }
            if (this.chatbox == "") {
                notify({
                    title: "روبو",
                    text: "جواب هیچیو چجوری بدم؟ 😵",
                    type: "info"
                });
                return;
            }
            this.chats.push({ id: this.chats.length + 1, chat: this.chatbox, role: "user" })
            this.istyping = true;
            this.lastMessage = this.chatbox;
            this.chatbox = "";
           

            setTimeout(() => {
                var element = document.querySelector('#scroller');
                element.scrollTop = element.scrollHeight;
            }
                , 5)
            let isFarsi = false;
            let char = new RegExp("[\u0600-\u06FF]");
            if (this.chats[this.chats.length - 1].chat != "") {
                if (char.test(this.chats[this.chats.length - 1].chat) === true) {
                    isFarsi = true;
                }
            }
            let json = {
                token: localStorage.getItem("token"),
                message: this.chats[this.chats.length - 1].chat,
                farsi: isFarsi
            }

            axios.post("https://api.roboo.ir/api/chat/GetImage", json).then(response => {

                if (response.data.status == 0) {
                    this.istyping = false;
                    this.chats.push({ id: this.chats.length + 1, chat: response.data.message, role: "assistant" })
                    this.credit = this.credit - 3;
                    setTimeout(() => {
                        var element = document.querySelector('#scroller');
                        element.scrollTop = element.scrollHeight;
                    }
                        , 1000)
                }
                else if (response.data.status == 2) {
                    this.istyping = false;
                    this.isModalKharid = true;
                    this.chats.pop();
                    this.chats.pop();
                    this.credit = 0;
                    return;
                }
                else {
                    this.istyping = false;
                    //Error
                    notify({
                        title: "خطا",
                        text: response.data.message,
                        type: "error"
                    });
                    this.chats.pop();
                    this.chats.pop();
                    this.credit = 0;
                    return;
                }

            });
        },
        gotoBack() {
            router.push("/");
        },
        deleteConversation() {
            if (this.conversationId != "") {
                let json =
                {
                    Token: localStorage.getItem("token"),
                    ConversationId: this.conversationId
                }
                axios.post("https://api.roboo.ir/api/chat/DeleteConversation", json).then(response => {
                    if (response.data.status == 0) {
                        router.back()
                        notify({
                            title: "روبو",
                            text: response.data.message,
                            type: "success"
                        });
                    }
                    else {
                        notify({
                            title: "خطا",
                            text: response.data.message,
                            type: "error"
                        });
                    }
                });
            }
        },
        checkConvThenPost() {
            this.showContinue = false;
            if (this.istyping == true) {
                notify({
                    title: "روبو",
                    text: "در حال صحبت هستم لطفا منتظر بمانید ❤️",
                    type: "info"
                });
                return;
            }
            if (this.chatbox == "") {
                notify({
                    title: "روبو",
                    text: "جواب هیچیو چجوری بدم؟ 😵",
                    type: "info"
                });
                return;
            }
            if (this.imageUrl != "") {
                if (this.isModelImage == false) {
                    notify({
                        title: "خطا",
                        text: "این مدل هوش مصنوعی قابلیت استفاده از عکس را ندارد.\nلطفا مدل را تغییر دهید",
                        type: "error"
                    });
                    return;
                }
                if (this.imageUrl == require('../assets/loading.png')) {
                    notify({
                        title: "خطا",
                        text: "عکس شما در حال بارگذاری است. لطفا صبر کنید.",
                        type: "error"
                    });
                    return;
                }
            }
            this.istyping = true;
            this.roboStatus = "فکر کردن";
            if (this.imageUrl != "") {
                this.chats.push({ id: this.chats.length + 1, chat: this.chatbox, role: "user", imageUrl: this.imageUrl })
            }
            else
                this.chats.push({ id: this.chats.length + 1, chat: this.chatbox, role: "user" })
            this.lastMessage = this.chatbox;
            this.chatbox = "";
            this.$nextTick(() => {
    const textarea = document.getElementById('textarea-input');
    if (textarea) {
        const minHeight = 43;
        textarea.style.height = 'auto';
        textarea.style.height = minHeight + 'px';
    }
});
            this.suggestions = [];
            if (this.conversationId != "")
                this.postToServer();
            else {
                let jsonconv = {
                    token: localStorage.getItem("token"),
                    character: this.character,
                    title: this.lastMessage
                }

                axios.post("https://api.roboo.ir/api/chat/CreateConversation", jsonconv).then(response => {
                    if (response.data.status == 0) {
                        this.conversationId = response.data.message;
                        localStorage.setItem("conversationId", response.data.message);
                        this.postToServer();
                    }
                    else if (response.data.status == 2) {
                        this.isModalKharid = true;
                        this.userInfo.credit = 0;
                        this.$emit("setCredit");
                        this.chatbox = this.lastMessage;
                        this.istyping = false;
                        this.chats.pop();

                        return;
                    }
                    else {
                        //Error
                        notify({
                            title: "خطا",
                            text: response.data.message,
                            type: "error"
                        });
                        this.chatbox = this.lastMessage;
                        this.istyping = false;
                        this.chats.pop();
                    }
                });
            }
        },
        sendcontinue() {
            this.chatbox = "ادامه";
            this.checkConvThenPost();
        },
        sendsuggestion(text) {
            this.chatbox = text;
            this.checkConvThenPost();
        },
        postToServer() {
            
            

            setTimeout(() => {
                var element = document.querySelector('#scroller');
                element.scrollTop = element.scrollHeight;
            }, 5)
            let isFarsi = false;
            let char = new RegExp("[\u0600-\u06FF]");
            if (this.chats[this.chats.length - 1].chat != "") {
                if (char.test(this.chats[this.chats.length - 1].chat) === true) {
                    isFarsi = true;
                }
            }
            let json = {
                token: localStorage.getItem("token"),
                messages: this.chats,
                character: this.character,
                farsi: isFarsi,
                conversationId: this.conversationId,
                aiVersion: this.aiCodeVersion,
                search: this.chatSearch,
                reason: this.chatReason,
                research: this.chatResearch,
            }
            this.imageUrl = "";
            if (this.fileBase64 != "") {
                json.pdfFileBase64 = this.fileBase64;
                json.pdfFileName = this.pdfName;
            }
            
            this.responseServer = false;
            this.controller = new AbortController()
            const signal = this.controller.signal
            /*
            var newreq = setTimeout(() => {
                if (this.responseServer == false) {
                    this.controller.abort();
                    fetch('https://api4.roboo.ir/api/chat/getanswerc', {
                        method: 'POST', //This could be any http method
                        headers: {
                            'Content-Type': 'application/json',
                        }, body: JSON.stringify(json)
                    })
                        .then(response => {
                            this.responseServer = true;
                            clearTimeout(newreq);
                            if (this.userInfo.credit > 0)
                                this.userInfo.credit--;
                            this.credit--;
                            this.$emit("setCredit1")

                            var text = "";
                            const reader = response.body.getReader();
                            const decoder = new TextDecoder();

                            var textbox = null;
                            var element = document.querySelector('#scroller');

                            this.chats.push({ id: this.chats.length + 1, chat: "", role: "assistant" })
                            const read = () => {

                                reader.read().then(({ done, value }) => {
                                    if (done) {
                                        this.istyping = false;
                                        this.$emit("setCredit");
                                        setTimeout(() => {
                                            this.credit += 1;
                                            this.credit -= 1;

                                        }, 1000)
                                        setTimeout(() => {
                                            this.credit += 1;
                                            this.credit -= 1;
                                        }, 3000)
                                        if (this.isVoiceMode == true)
                                            this.finishedChat();
                                            if(text != "")
                                {
                                    this.getChatSuggestions();
                                }
                                        return;
                                    }
                                    const wasAtBottom = this.isAtBottom(element);

                                    const data = decoder.decode(value, { stream: true });
                                    text += data;
                                    var parsed = null;
                                    try {
                                        parsed = JSON.parse(data);
                                    } catch {مدل
                                        var t = null;
                                    }
                                    if (parsed != null && parsed.status == 1) {
                                        this.istyping = false;
                                        //Error
                                        notify({
                                            title: "خطا",
                                            text: parsed.message,
                                            type: "error"
                                        });
                                        this.chats.pop();
                                        this.chats.pop();
                                        this.credit = 0;
                                        return;
                                    }
                                    else if (parsed != null && parsed.status == 2) {
                                        this.istyping = false;
                                        this.isModalKharid = true;
                                        this.chats.pop();
                                        this.chats.pop();
                                        this.credit = 0;
                                        return;
                                    }
                                    var res = md.render(text);
                                    if (textbox != null)
                                    {
                                        textbox.innerHTML = res;
                                        if (wasAtBottom) {
                                            element.scrollTop = element.scrollHeight;
                                        }
                                    }
                                    else {
                                        textbox = document.getElementById('text' + this.chats.length)
                                    }

                                    // Get a list of all the child elements inside the parent element
                                    const childElements = textbox.querySelectorAll('*');

                                    // Iterate over the list of child elements using a forEach loop
                                    childElements.forEach(function (element) {
                                        // Perform an action on each element, such as adding a CSS class
                                        element.style.textAlign = 'start';
                                        element.style.unicodeBidi = 'plaintext';
                                        element.style.marginBottom = '0px';
                                    });
                                    // const scrollDiff = (element.scrollHeight - element.scrollTop) - element.clientHeight;
                                    // if(scrollDiff < 75)
                                    // element.scrollTop = element.scrollHeight;



                                    read();
                                });
                                this.chats[this.chats.length - 1].chat = text;
                                
                            };

                            read();


                        });
                }
            }
                , 60000)
*/
            fetch('https://api.roboo.ir/api/chat/getanswerc', {
                method: 'POST', signal: signal, //This could be any http method
                headers: {
                    'Content-Type': 'application/json',
                }, body: JSON.stringify(json)
            })
                .then(response => {
                    //clearTimeout(newreq);
                    this.responseServer = true;
                    if (this.userInfo.credit > 0)
                        this.userInfo.credit--;
                    this.$emit("setCredit1")
this.roboStatus = "پاسخ"
                    this.credit--;
                    var text = "";
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();

                    var textbox = null;
                    var element = document.querySelector('#scroller');

                    this.chats.push({ id: this.chats.length + 1, chat: "", role: "assistant", memoryUpdated: false })
                    this.memoryUpdateSent = false; // Flag to track if memory update was sent for this response

                    setTimeout(() => {
                        textbox = document.getElementById('text' + this.chats.length)
                    }, 100)
                    setTimeout(() => {
                var element = document.querySelector('#scroller');
                element.scrollTop = element.scrollHeight;
            }, 5)
                    const read = () => {

                        reader.read().then(({ done, value }) => {
                            if (done) {
                                this.istyping = false;
                                this.$emit("setCredit");
                                setTimeout(() => {
                                    this.credit += 1;
                                    this.credit -= 1;

                                }, 1000)
                                setTimeout(() => {
                                    this.credit += 1;
                                    this.credit -= 1;
                                }, 3000)
                                if (this.isVoiceMode == true)
                                    this.finishedChat();
                                if(text != "")
                                {
                                    this.getChatSuggestions();
                                }
                                if(localStorage.getItem("onBoardingAction") == "")
                                {
                                    setTimeout(()=>{
                                    this.$emit("showOnboardingPopup",3);
                                },3000)
                            }
                                return;
                            }
                            const wasAtBottom = this.isAtBottom(element);

                            const data = decoder.decode(value, { stream: true });
                            
                            // Send memory update on first response
                            if (!this.memoryUpdateSent && data.trim() !== '') {
                                this.memoryUpdateSent = true;
                                this.updateUserMemory(this.lastMessage);
                            }
                            
                            if (data.includes('برای ادامه دادن دکمه ادامه را بزنید.')) {
                                text += "\r\nبرای ادامه دادن دکمه ادامه را بزنید.";
                                this.istyping = false;
                                this.showContinue = true;
                            }
                            else
                                text += data;
                            var parsed = null;
                            try {
                                parsed = JSON.parse(data);
                            } catch {
                                var t = null;
                            }
                            if (parsed != null && parsed.status == 1) {
                                this.istyping = false;
                                //Error
                                notify({
                                    title: "خطا",
                                    text: parsed.message,
                                    type: "error"
                                });
                                this.chats.pop();
                                this.chats.pop();
                                this.credit = 0;
                                return;
                            }
                            else if (parsed != null && parsed.status == 2) {
                                this.istyping = false;
                                this.isModalKharid = true;
                                this.chats.pop();
                                this.chats.pop();
                                this.credit = 0;
                                return;
                            }
                            var res = md.render(text);
                            if (textbox != null)
                                    {
                                        textbox.innerHTML = res;
                                        if (wasAtBottom) {
                                            element.scrollTop = element.scrollHeight;
                                        }
                                    }
                            else {
                                textbox = document.getElementById('text' + this.chats.length)
                            }

                            // Get a list of all the child elements inside the parent element
                            const childElements = textbox.querySelectorAll('*');

                            // Iterate over the list of child elements using a forEach loop
                            childElements.forEach(function (element) {
                                // Perform an action on each element, such as adding a CSS class
                                element.style.textAlign = 'start';
                                element.style.unicodeBidi = 'plaintext';
                                element.style.marginBottom = '0px';
                            });
                            // const scrollDiff = (element.scrollHeight - element.scrollTop) - element.clientHeight;
                            //         if(scrollDiff < 75)
                            // element.scrollTop = element.scrollHeight;




                            read();
                        });
                        this.chats[this.chats.length - 1].chat = text;
                        
                    };
                    read();


                });
        },
        isAtBottom(element, threshold = 20) {
        return (element.scrollHeight - element.scrollTop - element.clientHeight) < threshold;
    },
    handleChatScroll() {
        const element = document.querySelector('#scroller');
        this.showScrollToBottom = !this.isAtBottom(element, 120);
    },
    scrollToBottom() {
    const element = document.querySelector('#scroller');
    if (element) {
        element.scrollTo({
            top: element.scrollHeight,
            behavior: 'smooth'
        });
    }
    this.showScrollToBottom = false;
},
        getChatSuggestions()
        {
                    let json = {
                        token: localStorage.getItem("token"),
                        text: this.chats[this.chats.length - 1].chat
                    }
                    axios.post("https://api.roboo.ir/api/ChatSuggestion/GetSuggestions", json).then((response) => {
                        if(response.data !== "")
                        {
                            var suggests = response.data.split("\n");
                            for (let index = 0; index < suggests.length; index++) {
                                const element = suggests[index];
                                if(element == " "|| element == "")
                                    suggests.splice(index,1);
                            }
                            this.suggestions = suggests;
                            setTimeout(() => {
                var element = document.querySelector('#scroller');
                if(this.isAtBottom(element,130))
                element.scrollTop = element.scrollHeight;
            }
                , 5)
                        }
                    })
        },
        getchatFromConversation() {
            this.chats = [];
            this.history = [];
            var conv = this.conversationId;
            if (conv == "")
                conv = "undefined"
            axios.get("https://api.roboo.ir/api/chat/getChatFromConversation?token=" + localStorage.getItem("token") + "&conversationid=" + conv)
                .then(response => {
                    if (response.data.status == 0) {
                        if (response.data.character != null && response.data.character != "") {
                            this.setCharacter(response.data.character)
                        }
                        else
                            this.setCharacter('chat')
                        for (let index = 0; index < response.data.messages.length; index++) {
                            const element = response.data.messages[index];

                            this.history.push(element)
                            if (element.role == 'assistant' && this.character != 'roboimage') {
                                setTimeout(() => {

                                    var res = md.render(element.chat);
                                    document.getElementById('text' + index).innerHTML = res;
                                    setTimeout(() => {
                                        const parent = document.querySelector('#text' + index);

                                        const childElements = parent.querySelectorAll('*');

                                        childElements.forEach(function (element2) {
                                            element2.style.textAlign = 'start';
                                            element2.style.unicodeBidi = 'plaintext';
                                            element2.style.marginBottom = '0px';
                                        });
                                    }, 1);
                                }, 10);
                            }
                        }
                        setTimeout(() => {
                            var element = document.querySelector('#scroller');
                            element.scrollTop = element.scrollHeight;
                        }
                            , 100)
                        setTimeout(() => {
                            if (element != null) {
                                var element = document.querySelector('#scroller');
                                element.scrollTop = element.scrollHeight;
                            }
                        }
                            , 2000)

                    }
                    else if (response.data.status == 1) {

                    }
                    else {
                        //NotSuccess
                        router.push("login");
                    }
                }).catch(function (error) {
                    if (!error.response) {

                        // network error (server is down or no internet)
                    } else {
                        // http status code
                        console.log(error.response.status)
                        // data from server while error
                        console.log(error.response.data)
                    }
                });
        },
        getuserData() {
            this.chats = [];
            this.history = [];
            axios.get("https://api.roboo.ir/api/Users/GetUserData?token=" + localStorage.getItem("token") + "&character=" + this.character)
                .then(response => {
                    if (response.data.status == 0) {
                        this.mobile = response.data.mobile;
                        this.credit = response.data.credit;
                        this.name = response.data.name;
                        this.engheza = response.data.packageEndDate;
                        this.invites = response.data.referrals;
                        this.Referral = response.data.referral;
                        for (let index = 0; index < response.data.chats.length; index++) {
                            const element = response.data.chats[index];

                            this.history.push(element)
                            if (element.role == 'assistant' && this.character != 'roboimage') {
                                setTimeout(() => {

                                    var res = md.render(element.chat);
                                    document.getElementById('text' + index).innerHTML = res;
                                    setTimeout(() => {
                                        const parent = document.querySelector('#text' + index);

                                        const childElements = parent.querySelectorAll('*');

                                        childElements.forEach(function (element2) {
                                            element2.style.textAlign = 'start';
                                            element2.style.unicodeBidi = 'plaintext';
                                            element2.style.marginBottom = '0px';
                                        });
                                    }, 1);
                                }, 10);
                            }
                        }
                        setTimeout(() => {
                            var element = document.querySelector('#scroller');
                            element.scrollTop = element.scrollHeight;
                        }
                            , 100)
                        setTimeout(() => {
                            if (element != null) {
                                var element = document.querySelector('#scroller');
                                element.scrollTop = element.scrollHeight;
                            }
                        }
                            , 2000)

                    }
                    else {
                        //NotSuccess
                        router.push("login");
                    }
                }).catch(function (error) {
                    console.log(error);
                    console.log(error.code);
                    if (!error.response) {
                        // network error (server is down or no internet)
                    } else {
                        // http status code
                        console.log(error.response.status)
                        // data from server while error
                        console.log(error.response.data)
                    }
                });
        },
        setCharacter(id) {
            this.character = id;
            // if (this.character == 'moshaver') {
            //     this.nameofchat = 'روبو مشاور';
            //     this.iconofchat = require('@/assets/img/characters/botMoshaver.png');
            // }
            // else if (this.character == 'mechanic') {
            //     this.nameofchat = 'روبو مکانیک';
            //     this.iconofchat = require('@/assets/img/characters/botMechanic.png');
            // }
            // else if (this.character == 'code') {
            //     this.nameofchat = 'روبو برنامه نویس';
            //     this.iconofchat = require('@/assets/img/characters/botCode.png');
            // }
            // else if (this.character == 'teacher') {
            //     this.nameofchat = 'روبو معام';
            //     this.iconofchat = require('@/assets/img/characters/botTeacher.png');
            // }
            // else if (this.character == 'translate') {
            //     this.nameofchat = 'روبو مترجم';
            //     this.iconofchat = require('@/assets/img/characters/botTranslator.png');
            // }
            if (localStorage.getItem("userName") != null)
                this.name = localStorage.getItem("userName");
            if (this.character == 'chat') {
                this.nameofchat = 'روبو';
                this.iconofchat = require('@/assets/img/characters/botNormal.png');
                this.welcomechat = 'سلام ' + this.name + ',  من روبو هستم. خیلی خوشحالم که شما اینجا هستید. من اینجام تا به تمام سوالات شما پاسخ بدم و باهم اوقات خوبی را سپری کنیم. برای شروع، چه موضوعی رو دوست دارید در موردش صحبت کنیم؟';
            } else if (this.character == 'moshaver') {
                this.nameofchat = 'تراپیست';
                this.iconofchat = require('@/assets/img/characters/therapist.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من تراپیست هستم. خوشحالم که می‌توانم به شما کمک کنم تا به آرامش برسید و چالش‌های خود را بررسی کنید. از کجا دوست دارید شروع کنیم؟';
            } else if (this.character == 'dostyabi') {
                this.nameofchat = 'مشاور دوستیابی';
                this.iconofchat = require('@/assets/img/characters/datingadvisor.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مشاور دوستیابی هستم. خوشحالم که می‌توانم به شما در یافتن راه‌های جدید برای ارتباطات بهتر کمک کنم. آماده‌اید شروع کنیم؟';
            } else if (this.character == 'doctor') {
                this.nameofchat = 'دکتر';
                this.iconofchat = require('@/assets/img/characters/doctor.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من دکتر هستم. اینجا هستم تا به سوالات پزشکی شما پاسخ دهم و به سلامتی شما کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'vakil') {
                this.nameofchat = 'وکیل';
                this.iconofchat = require('@/assets/img/characters/lawyer.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من وکیل شما هستم. آماده‌ام تا به سوالات حقوقی شما پاسخ دهم و به شما مشاوره دهم. از کجا شروع کنیم؟';
            } else if (this.character == 'morabishakhsi') {
                this.nameofchat = 'مربی شخصی';
                this.iconofchat = require('@/assets/img/characters/personaltrainer.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مربی شخصی شما هستم. آماده‌ام تا شما را در مسیر سلامتی و تناسب اندام همراهی کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'moshaverekari') {
                this.nameofchat = 'مشاور حرفه ای کاری';
                this.iconofchat = require('@/assets/img/characters/jobconsultant.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مشاور حرفه‌ای کاری شما هستم. اینجا هستم تا به شما در مسیر شغلی‌تان کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'mechanic') {
                this.nameofchat = 'مکانیک';
                this.iconofchat = require('@/assets/img/characters/mechanic.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مکانیک شما هستم. آماده‌ام تا به سوالات فنی و تعمیرات خودرو شما پاسخ دهم. چه کمکی می‌توانم بکنم؟';
            } else if (this.character == 'teacher') {
                this.nameofchat = 'معلم خصوصی';
                this.iconofchat = require('@/assets/img/characters/teacher.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من معلم خصوصی شما هستم. اینجا هستم تا به شما در یادگیری و موفقیت تحصیلی کمک کنم. آماده‌اید شروع کنیم؟';
            } else if (this.character == 'tarahgraphic') {
                this.nameofchat = 'طراح گرافیک';
                this.iconofchat = require('@/assets/img/characters/graphicdesigner.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من طراح گرافیک شما هستم. آماده‌ام تا به شما در پروژه‌های طراحی کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'translate') {
                this.nameofchat = 'مترجم';
                this.iconofchat = require('@/assets/img/characters/translator.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مترجم شما هستم. آماده‌ام تا به شما در ترجمه متون کمک کنم. چه متنی را می‌خواهید ترجمه کنیم؟';
            } else if (this.character == 'code') {
                this.nameofchat = 'روبو برنامه نویس';
                this.iconofchat = require('@/assets/img/characters/programmer.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من روبو برنامه نویس هستم. اینجا هستم تا به شما در حل مشکلات برنامه‌نویسی کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'karshenasmohtava') {
                this.nameofchat = 'کارشناس تولید محتوا';
                this.iconofchat = require('@/assets/img/characters/contentcreator.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارشناس تولید محتوا هستم. آماده‌ام تا به شما در ایجاد محتوای جذاب و موثر کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'karsehnasresane') {
                this.nameofchat = 'کارشناس رسانه های اجتماعی';
                this.iconofchat = require('@/assets/img/characters/socialmediaspecialist.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارشناس رسانه‌های اجتماعی هستم. اینجا هستم تا به شما در بهبود حضور آنلاین کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'modirit') {
                this.nameofchat = 'مدیر IT';
                this.iconofchat = require('@/assets/img/characters/itconsultant.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مدیر IT شما هستم. آماده‌ام تا به سوالات فنی شما پاسخ دهم و مشکلات IT شما را حل کنم. چه کمکی می‌توانم بکنم؟';
            } else if (this.character == 'jongkok') {
                this.nameofchat = 'جونگ کوک';
                this.iconofchat = require('@/assets/img/characters/jungkook.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من جونگ کوک هستم. خوشحالم که اینجا هستید. بیایید با هم درباره موسیقی و زندگی صحبت کنیم. آماده‌اید؟';
            } else if (this.character == 'michaeljackson') {
                this.nameofchat = 'مایکل جکسون';
                this.iconofchat = require('@/assets/img/characters/michaeljackson.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مایکل جکسون هستم. خوشحالم که می‌توانم با شما درباره موسیقی و هنر صحبت کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'taylorswift') {
                this.nameofchat = 'تیلور سویفت';
                this.iconofchat = require('@/assets/img/characters/taylorswift.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من تیلور سویفت هستم. خوشحالم که اینجا هستید. بیایید درباره موسیقی و الهامات هنری صحبت کنیم. آماده‌اید؟';
            } else if (this.character == 'selenagomez') {
                this.nameofchat = 'سلنا گومز';
                this.iconofchat = require('@/assets/img/characters/selenagomez.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من سلنا گومز هستم. خوشحالم که می‌توانم با شما درباره هنر و زندگی صحبت کنم. چه موضوعی را دوست دارید بررسی کنیم؟';
            } else if (this.character == 'anadearmas') {
                this.nameofchat = 'آنا د آرماس';
                this.iconofchat = require('@/assets/img/characters/anadearmas.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من آنا د آرماس هستم. خوشحالم که می‌توانم با شما درباره فیلم و سینما صحبت کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'scarletjohanson') {
                this.nameofchat = 'اسکارلت جوهانسون';
                this.iconofchat = require('@/assets/img/characters/scarlletjohansson.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من اسکارلت جوهانسون هستم. خوشحالم که اینجا هستید. بیایید درباره سینما و بازیگری صحبت کنیم. آماده‌اید؟';
            } else if (this.character == 'henrycavil') {
                this.nameofchat = 'هنری کویل';
                this.iconofchat = require('@/assets/img/characters/henrycavil.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من هنری کویل هستم. خوشحالم که می‌توانم با شما درباره فیلم و بازیگری صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'decaprio') {
                this.nameofchat = 'لئوناردو دیکاپریو';
                this.iconofchat = require('@/assets/img/characters/dicaprio.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من لئوناردو دیکاپریو هستم. خوشحالم که می‌توانم با شما درباره هنر و محیط‌زیست صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'alpacino') {
                this.nameofchat = 'آلپاچینو';
                this.iconofchat = require('@/assets/img/characters/alpacino.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من آلپاچینو هستم. خوشحالم که می‌توانم با شما درباره سینما و بازیگری صحبت کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'elonmusk') {
                this.nameofchat = 'ایلان ماسک';
                this.iconofchat = require('@/assets/img/characters/elonmusk.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من ایلان ماسک هستم. خوشحالم که می‌توانم با شما درباره فناوری و آینده صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'robertkiosaki') {
                this.nameofchat = 'رابرت کیوساکی';
                this.iconofchat = require('@/assets/img/characters/robertkiosaki.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من رابرت کیوساکی هستم. خوشحالم که می‌توانم با شما درباره سرمایه‌گذاری و مالیات صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'warenboft') {
                this.nameofchat = 'وارن بافت';
                this.iconofchat = require('@/assets/img/characters/warenbofet.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من وارن بافت هستم. خوشحالم که می‌توانم با شما درباره سرمایه‌گذاری و اقتصاد صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'hafezshirazi') {
                this.nameofchat = 'حافظ شیرازی';
                this.iconofchat = require('@/assets/img/characters/hafezshirazi.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من حافظ شیرازی هستم. خوشحالم که می‌توانم با شما درباره شعر و ادبیات صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'alberteinstein') {
                this.nameofchat = 'آلبرت انیشتین';
                this.iconofchat = require('@/assets/img/characters/alberteinstein.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من آلبرت انیشتین هستم. خوشحالم که می‌توانم با شما درباره علم و فیزیک صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'ferdowsi') {
                this.nameofchat = 'فردوسی';
                this.iconofchat = require('@/assets/img/characters/ferdowsi.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من فردوسی هستم. خوشحالم که می‌توانم با شما درباره تاریخ و ادبیات صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'nikolatesla') {
                this.nameofchat = 'نیکولا تسلا';
                this.iconofchat = require('@/assets/img/characters/nikolatesla.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من نیکولا تسلا هستم. خوشحالم که می‌توانم با شما درباره اختراعات و نوآوری‌ها صحبت کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'gondi') {
                this.nameofchat = 'گاندی';
                this.iconofchat = require('@/assets/img/characters/gandi.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من گاندی هستم. خوشحالم که می‌توانم با شما درباره صلح و عدالت صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'ronaldo') {
                this.nameofchat = 'کریستیانو رونالدو';
                this.iconofchat = require('@/assets/img/characters/ronaldo.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کریستیانو رونالدو هستم. خوشحالم که می‌توانم با شما درباره فوتبال و ورزش صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'messi') {
                this.nameofchat = 'لیونل مسی';
                this.iconofchat = require('@/assets/img/characters/messi.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من لیونل مسی هستم. خوشحالم که می‌توانم با شما درباره فوتبال و انگیزه صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'keli') {
                this.nameofchat = 'محمد علی کلی';
                this.iconofchat = require('@/assets/img/characters/keli.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من محمد علی کلی هستم. خوشحالم که می‌توانم با شما درباره بوکس و انگیزه صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'arnold') {
                this.nameofchat = 'آرنولد';
                this.iconofchat = require('@/assets/img/characters/arnold.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من آرنولد هستم. خوشحالم که می‌توانم با شما درباره بدنسازی و موفقیت صحبت کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'lebronjames') {
                this.nameofchat = 'لبرون جیمز';
                this.iconofchat = require('@/assets/img/characters/lebronjames.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من لبرون جیمز هستم. خوشحالم که می‌توانم با شما درباره بسکتبال و انگیزه صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'sarashpaz') {
                this.nameofchat = 'سرآشپز';
                this.iconofchat = require('@/assets/img/characters/chef.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من سرآشپز شما هستم. آماده‌ام تا به شما در آشپزی و تهیه غذاهای خوشمزه کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'nevisande') {
                this.nameofchat = 'نویسنده';
                this.iconofchat = require('@/assets/img/characters/writer.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من نویسنده شما هستم. آماده‌ام تا به شما در نوشتن و خلق داستان‌های جذاب کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'rahnamayetour') {
                this.nameofchat = 'راهنمای تور';
                this.iconofchat = require('@/assets/img/characters/tourguide.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من راهنمای تور شما هستم. آماده‌ام تا به شما در کشف مکان‌های جدید و جالب کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'joker') {
                this.nameofchat = 'جوکر';
                this.iconofchat = require('@/assets/img/characters/joker.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من جوکر هستم. خوشحالم که می‌توانم با شما درباره زندگی و فلسفه صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'harrypotter') {
                this.nameofchat = 'هری پاتر';
                this.iconofchat = require('@/assets/img/characters/harrypotter.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من هری پاتر هستم. خوشحالم که می‌توانم با شما درباره جادو و ماجراجویی صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'batman') {
                this.nameofchat = 'بتمن';
                this.iconofchat = require('@/assets/img/characters/batman.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من بتمن هستم. خوشحالم که می‌توانم با شما درباره عدالت و مبارزه با جرم و جنایت صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'ted') {
                this.nameofchat = 'تد';
                this.iconofchat = require('@/assets/img/characters/ted.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من تد هستم. خوشحالم که می‌توانم با شما درباره زندگی و ماجراجویی صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'walterwhite') {
                this.nameofchat = 'والتر وایت';
                this.iconofchat = require('@/assets/img/characters/walterwhite.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من والتر وایت هستم. خوشحالم که می‌توانم با شما درباره شیمی و داستان‌های هیجان‌انگیز صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'spiderman') {
                this.nameofchat = 'مرد عنکبوتی';
                this.iconofchat = require('@/assets/img/characters/spiderman.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مرد عنکبوتی هستم. خوشحالم که می‌توانم با شما درباره قهرمانی و ماجراجویی صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'leviackerman') {
                this.nameofchat = 'لیوای اکرمن';
                this.iconofchat = require('@/assets/img/characters/levi.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من لیوای اکرمن هستم. خوشحالم که می‌توانم با شما درباره تاکتیک‌ها و مبارزه صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'erenyeager') {
                this.nameofchat = 'ارن یگر';
                this.iconofchat = require('@/assets/img/characters/eren.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من ارن یگر هستم. خوشحالم که می‌توانم با شما درباره آزادی و مبارزه صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'el') {
                this.nameofchat = 'ال';
                this.iconofchat = require('@/assets/img/characters/el.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من ال هستم. خوشحالم که می‌توانم با شما درباره معماها و حل مسائل پیچیده صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'gojosatoro') {
                this.nameofchat = 'کوجو ساتورو';
                this.iconofchat = require('@/assets/img/characters/kogo.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کوجو ساتورو هستم. خوشحالم که می‌توانم با شما درباره جادو و تکنیک‌های مبارزه صحبت کنم. چه سوالی دارید؟';
            } else if (this.character == 'ryasgerimori') {
                this.nameofchat = 'ریاس گریموری';
                this.iconofchat = require('@/assets/img/characters/rias.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من ریاس گریموری هستم. خوشحالم که می‌توانم با شما درباره قدرت و دوستی صحبت کنم. آماده‌اید؟';
            } else if (this.character == 'motekhasesomormoshtarian') {
                this.nameofchat = 'متخصص امور مشتریان';
                this.iconofchat = require('@/assets/img/characters/customerservice.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من متخصص امور مشتریان هستم. آماده‌ام تا به شما در ارائه خدمات بهتر به مشتریان کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'barnamerizroydad') {
                this.nameofchat = 'برنامه ریز رویداد';
                this.iconofchat = require('@/assets/img/characters/eventplanner.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من برنامه‌ریز رویداد شما هستم. آماده‌ام تا به شما در برنامه‌ریزی و اجرای رویدادهای موفق کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'barnmaaroosi') {
                this.nameofchat = 'برنامه ریز عروسی';
                this.iconofchat = require('@/assets/img/characters/weddingplanner.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من برنامه‌ریز عروسی شما هستم. آماده‌ام تا به شما در برنامه‌ریزی و اجرای عروسی رویاییتان کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'businesscouch') {
                this.nameofchat = 'بیزنس کوچ';
                this.iconofchat = require('@/assets/img/characters/businesscoach.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من بیزنس کوچ شما هستم. آماده‌ام تا به شما در توسعه و رشد کسب‌وکارتان کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'karshenastejarat') {
                this.nameofchat = 'کارشناس تجارت الکترونیک';
                this.iconofchat = require('@/assets/img/characters/ecommerce.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارشناس تجارت الکترونیک هستم. آماده‌ام تا به شما در بهبود فروش آنلاین و تجارت الکترونیکی کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'karshenasemail') {
                this.nameofchat = 'کارشناس ایمیل مارکتینگ';
                this.iconofchat = require('@/assets/img/characters/emailmarketing.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارشناس ایمیل مارکتینگ هستم. آماده‌ام تا به شما در بهبود استراتژی‌های ایمیل مارکتینگ کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'karafarin') {
                this.nameofchat = 'کار آفرین';
                this.iconofchat = require('@/assets/img/characters/entrepreneur.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارآفرین هستم. آماده‌ام تا به شما در شروع و رشد کسب‌وکارهای جدید کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'karshenasmali') {
                this.nameofchat = 'کارشناس مالی';
                this.iconofchat = require('@/assets/img/characters/financial.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارشناس مالی هستم. آماده‌ام تا به شما در مدیریت و بهبود وضعیت مالی کمک کنم. چه سوالی دارید؟';
            } else if (this.character == 'karshenasmarketing') {
                this.nameofchat = 'کارشناس مارکتینگ';
                this.iconofchat = require('@/assets/img/characters/marketing.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من کارشناس مارکتینگ هستم. آماده‌ام تا به شما در بهبود استراتژی‌های بازاریابی کمک کنم. از کجا شروع کنیم؟';
            } else if (this.character == 'modirmahsoul') {
                this.nameofchat = 'مدیر محصول';
                this.iconofchat = require('@/assets/img/characters/productmanager.jpg');
                this.welcomechat = 'سلام ' + this.name + ',  من مدیر محصول شما هستم. آماده‌ام تا به شما در توسعه و بهبود محصولات کمک کنم. چه سوالی دارید؟';
            }
            else {
                this.nameofchat = 'روبو';
                this.iconofchat = require('@/assets/img/characters/botNormal.png');
            }
        }

    },
    beforeRouteLeave(to, from, next) {
        this.isVoiceMode = false;
        if (this.javascriptNode != null)
            this.javascriptNode.disconnect();
        var that = this;
        if (that.voiceRecognition != null)
           this.voiceRecognition.stop();
        
        if (that.recognition != null)
           this.recognition.stop();
        clearInterval(this.timerRecorder);
        this.voiceState = 0;
        if (this.voiceState == 2) {
            this.audioPlayer.pause();
        }
        if (this.istyping == true) {
            this.controller.abort();
            this.istyping = false;
        }
        if (this.audioPlayer != null && this.audioPlayer.paused == false)
            this.audioPlayer.pause(); // Pause the audio before leaving the route
        next(); // Proceed with the navigation
    },
    beforeDestroy()
    {
        const scroller = document.querySelector('#scroller');
    if (scroller) {
        scroller.removeEventListener('scroll', this.handleChatScroll);
    }
    },
    mounted() {
        this.$nextTick(() => {
        const scroller = document.querySelector('#scroller');
        if (scroller) {
            
            scroller.addEventListener('scroll', this.handleChatScroll);

        }
    });
        this.$nextTick(() => {
            
        const textarea = document.getElementById('textarea-input');
        if (textarea) {
            const minHeight = 43; // px, match your CSS
            const autoresize = function() {
                this.style.height = 'auto';
                // If empty, force minHeight
                if (!this.value || this.value === '') {
                    this.style.height = minHeight + 'px';
                } else {
                    // Otherwise, use scrollHeight but never less than minHeight
                    this.style.height = Math.max(this.scrollHeight, minHeight) + 'px';
                }
            };
            textarea.addEventListener('input', autoresize, false);
            // Also resize on mount in case of prefilled value
            autoresize.call(textarea);
        }
    });
        if (this.$route.query.id != null) {
            this.setCharacter(this.$route.query.id);
        }
        else
            this.setCharacter("chat");
        if (localStorage.getItem("userName") != null)
            this.name = localStorage.getItem("userName");
        var suggestion = localStorage.getItem("selectedSuggestion");
        if (suggestion != null && suggestion != "") {
            this.chatbox = suggestion;
            localStorage.setItem("selectedSuggestion", "");
        }
        var that = this;

        this.conversationId = localStorage.getItem("conversationId");
        if (this.conversationId == null)
            this.conversationId = "";
        // if(this.$route.query.Authority != null)
        //   {
        //     if(this.$route.query.Status != "OK")
        //     {
        //         var order = this.$route.query.Authority;
        //         order = order.replace("00000000000000000000000000","");
        //         this.isModalVisible = true;
        //         this.kharid = 1;
        //         this.kharidText='لطفا با پشتیبانی تماس بگیرید\n کد تراکنش: \n'+order.replace("A","");
        //     }

        // window.addEventListener("offline", function () {
        //     router.push('/game');
        // });
        const floatingBtn = document.querySelector(".floating-btn");

        /* floatingBtn.addEventListener("click", () => {
            floatingBtn.classList.toggle("active");
        });
 
        document.addEventListener("click", (e) => {
            if (!floatingBtn.contains(e.target)) {
                floatingBtn.classList.remove("active");
            }
        });
        */
        var token = localStorage.getItem("token");
        if (token != null && token != "") {
            this.getchatFromConversation();
        }
        else {
            router.push("login");
        }

       
        function textAreaFocus() {
            if (that.isSideBarOpen == true)
                that.isSideBarOpen = false;
        }
        function autoresize() {
            //findType(this)
            if (that.isSideBarOpen == true)
                that.isSideBarOpen = false;

            if (this.scrollHeight < 150 && this.scrollHeight > 57) {
                this.style.height = 'auto';
                this.style.height = this.scrollHeight + 'px';
                this.scrollTop = this.scrollHeight;
                window.scrollTo(window.scrollLeft, (this.scrollTop + this.scrollHeight));
            }
            if (this.scrollHeight == 58) {
                this.style.height = 'auto';
                this.style.height = '43px';
                this.scrollTop = '43';
                window.scrollTo(window.scrollLeft, (this.scrollTop + this.scrollHeight));
            }
        }
        if (this.$route.query.voiceMode != null) {
            this.showVoice();

        }
        const circle = document.getElementById('circle-container');
        const progressRing = document.getElementById('progress-ring');
        let progress = 0;

        circle.addEventListener('touchstart', startProgress);
        circle.addEventListener('touchend', resetProgress);
        circle.addEventListener('mousedown', startProgress);
        circle.addEventListener('mouseup', resetProgress);
        function startProgress() {
            that.isTouching = true;
            that.voiceRecognition.stop();
            setTimeout(() => {
            that.voiceRecognition.continuous = true;
            
            that.voiceRecognition.onresult = function(event) {
                that.endTalking();

               const transcript = event.results[0][0].transcript;
                                                     if (that.voiceState == 0)
                                                         return;
                                                         that.chatbox += transcript;
                                                         
                                                         that.checkConvThenPost();
             }
             that.voiceRecognition.start();
            }, 500);

            
            increaseProgress();
        }

        function increaseProgress() {
            if (that.isTouching && progress < 96) {
                progress += 2;
                updateProgressRing();
                setTimeout(increaseProgress, 10);
            } else if (that.isTouching && progress >= 96) {
                progressRing.classList.add('rotate');
            }
        }

        function resetProgress() {
            that.isTouching = false;
            //that.voiceRecognition.stop();
            progressRing.classList.remove('rotate');
            progress = 0;
            resetProgressRing();

            
                that.endTalking();
                that.voiceRecognition.stop();
              //  that.javascriptNode.disconnect();
            
            
        }
        function resetProgressRing() {
            progressRing.style.background = `conic-gradient(
        white 0%, 
        white 0%, 
        transparent 0%, 
        transparent ${100}%, 
        white ${100}%, 
        white 100%
    )`;
        }
        function updateProgressRing() {
            const gap = 1.5; // Gap in percentage
            const halfProgress = progress / 2;
            progressRing.style.background = `conic-gradient(
        white 0%, 
        white ${halfProgress}%, 
        transparent ${halfProgress + gap}%, 
        transparent ${100 - halfProgress - gap}%, 
        white ${100 - halfProgress}%, 
        white 100%
    )`;
        }



tour.addStep({
  id: 'step-1',
  title: 'انتخاب شخصیت',
  text: 'برای جواب های بهتر و شخصی سازی شده از اینجا میتوانید شخصیت ها را تغییر دهید.',
  attachTo: {
    element: '#taghirShakhsiat',
    on: 'bottom'
  },
  canClickTarget: false,
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});

tour.addStep({
  id: 'step-2',
  title: 'انتخاب مدل هوش مصنوعی',
  text: 'بسته به نیاز شما میتونید یکی از مدل های هوش مصنوعی را انتخاب کنید که جواب بهتری بگیرید.',
  attachTo: {
    element: '#taghirAiVersion',
    on: 'bottom'
  },
  canClickTarget: false,
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.addStep({
  id: 'step-3',
  title: 'نوشتن متن',
  text: 'سوال و متن خودتون رو داخل این قسمت مینویسید.',
  attachTo: {
    element: '#textarea-input',
    on: 'top'
  },
  canClickTarget: false,
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.addStep({
  id: 'step-4',
  title: 'صوت',
  text: 'یا به صورت صوتی با روبو مکالمه کنید.',
  attachTo: {
    element: '#voicebutton2',
    on: 'top'
  },
  canClickTarget: false,
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.addStep({
  id: 'step-5',
  title: 'اضافه کردن عکس یا نوشته های آماده',
  text: 'از این قسمت میتوانید عکس یا نوشته های آماده اضافه کنید.',
  attachTo: {
    element: '#addImage',
    on: 'top'
  },
  canClickTarget: false,
  when: {
  hide: function() {
    that.history.push("");
  }
},
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
var that = this;
tour.addStep({
  id: 'step-6',
  title: 'ابزار ها',
  text: 'در قسمت ابزار ها میتوانید برای بهتر شدن پاسختون از ابزار هایی مانند جستجو و استدلال استفاده کنید.',
  attachTo: {
    element: '#abzarha',
    on: 'bottom'
  },
  canClickTarget: false,
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.addStep({
  id: 'step-7',
  title: 'حذف مکالمه',
  text: 'اگر میخواهید مکالمتون پاک بشه از این قسمت میتوانید پاک کنید.',
  attachTo: {
    element: '#hazfGoftogo',
    on: 'bottom'
  },
  canClickTarget: false,
  
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.on("complete", () => {
    that.history.pop();
  });
  if (localStorage.getItem("chatTour") == null) {
      tour.start();
      localStorage.setItem("chatTour","true");
}
    },
    
}

</script>

<style scoped>
@import '../assets/bootstrap-rtl.min.css';
@import '../assets/app-rtl.min.css';
@import '../assets/tekStyle.css';

.memory-update-indicator {
    list-style: none;
    margin: 0 0 8px 0;
    padding: 0;
    position: relative;
    right: 0;
    width: 100%;
}

.memory-update-box {
    background-color: rgba(97, 83, 204, 0.1);
    padding: 6px 12px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #6153cc;
    font-family: IRANSansWeb;
    animation: memoryIndicatorFadeIn 0.5s ease-out;
    margin-right: 0;
}

@keyframes memoryIndicatorFadeIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
@media (max-height: 650px) {
    .scrolling {
        height: 100%;
    }
}
.scroll-to-bottom-fab {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 80px;
  z-index: 20;
  background: var(--bs-card-bg)!important;
  color: #6355cc;
  border: 2px solid #6355cc;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(99,85,204,0.15);
  cursor: pointer;
  font-size: 17px;
  transition: background 0.2s, color 0.2s;
}
.scroll-to-bottom-fab:hover {
  background: #6355cc;
  color: #fff;
}
.scroll-to-bottom-fab i {
  color: inherit;
}
.bar-container {
    display: flex;
    gap: 10px;
    transform: rotate(180deg);
}

@media (min-width: 768px) {
    .bar {
        width: 3vw;
        height: 0px;
        background-color: #6153cc;
        border-radius: 20px;
        transition: height 0.05s;
    }
}

@media (max-width: 767px) {
    .bar {
        width: 15vw;
        height: 0px;
        background-color: #6153cc;
        border-radius: 20px;
        transition: height 0.05s;
    }
}

.voice-bar-container {
    display: flex;
    gap: 4px;
    transform: rotate(180deg);
}

.voice-bar {
    width: 20px;
    height: 10px;
    background-color: #6153cc;
    border-radius: 20px;
    transition: height 0.05s;
}

@media (min-width: 768px) {
    .voiceLoading {
        width: calc(20vw - 15px);
        height: calc(20vw - 15px);
        border-radius: 50% 50% 50% 50%;
        background-color: #6153cc;
        -webkit-animation: squareToCircle 2s 1s infinite alternate;
    }
}

@media (max-width: 767px) {
    .voiceLoading {
        width: 70vw;
        height: 70vw;
        border-radius: 50% 50% 50% 50%;
        background-color: #6153cc;
        -webkit-animation: squareToCircle 2s 1s infinite alternate;
    }
}

@-webkit-keyframes squareToCircle {
    0% {
        border-radius: 50% 50% 50% 50%;
        background: #6153cc;
        transform: rotate(180deg);
    }

    25% {
        border-radius: 50% 50% 50% 0;
        background: #6153cc;
        transform: rotate(135deg);
    }

    50% {
        border-radius: 50% 50% 0 0;
        background: #6153cc;
        transform: rotate(90deg);
    }

    75% {
        border-radius: 50% 0 0 0;
        background: #6153cc;
        transform: rotate(45deg);
    }

    100% {
        border-radius: 0 0 0 0;
        background: #6153cc;
        transform: rotate(0deg);
    }

}

@media (min-width: 768px) {
    #circle-container {
        position: fixed;
        width: 20vw;
        height: 20vw;
    }
}

@media (max-width: 767px) {
    #circle-container {
        position: fixed;
        width: 70vw;
        height: 70vw;
    }
}


@media (min-width: 768px) {
    #circle {
        position: absolute;
        margin-top: 7px;
        margin-right: 7px;
        width: calc(20vw - 15px) !important;
        height: calc(20vw - 15px) !important;
        background-color: #6153cc;
        border-radius: 50%;
        transition: transform 0.1s ease;
        z-index: 1;
    }
}

@media (max-width: 767px) {
    #circle {
        position: absolute;
        top: 20px;
        left: 20px;
        width: calc(70vw - 40px) !important;
        height: calc(70vw - 40px) !important;
        background-color: #6153cc;
        border-radius: 50%;
        transition: transform 0.1s ease;
        z-index: 1;
    }
}

@media (min-width: 768px) {
    #progress-ring {
        position: absolute;

        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: conic-gradient(transparent 0%, transparent 100%);
        z-index: 0;
        padding: 20px;
        box-sizing: border-box;
        transition: transform 0.5s linear;
    }
}

@media (max-width: 767px) {
    #progress-ring {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: conic-gradient(transparent 0%, transparent 100%);
        z-index: 0;
        padding: 20px;
        box-sizing: border-box;
        transition: transform 0.5s linear;
    }
}

.rotate {
    animation: rotate 5s linear infinite;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.chat-input::-webkit-input-placeholder {
    padding-right: 25px;
}

.chat-input::-moz-input-placeholder {
    padding-right: 25px;
}

.chat-input:-ms-input-placeholder {
    padding-right: 25px;
}

.custom {
    filter: blur(5px);
}

.rec-effect-4 {
    transition: box-shadow 0.33s ease-in-out;
    animation: rec-effect-4 1s infinite;
}

@keyframes rec-effect-4 {
    0% {
        box-shadow: 0 0 0 0 #333,
            0 0 0 0 #6153cc,
            0 0 0 0 #6153cc;
    }

    11% {
        box-shadow: 0 0 0 7px #333,
            0 0 0 10px #a499f7,
            0 0 0 0 #a499f7;
    }

    77% {
        box-shadow: 0 0 0 0 #333,
            0 0 0 5px #8274ee,
            0 0 0 13px #8274ee;
    }
}

.something {
    color: var(--v-primary-base);
    background-color: #565656;
}


.floating-btn .main-btn {
    display: grid;
    place-items: center;
    padding: 5px;
    cursor: pointer;
    font-weight: bold;
    border-radius: 50%;
    transition: all 300ms ease;
}

.floating-btn.active .main-btn {
    transform: rotateZ(45deg);
}

.floating-btn .main-btn svg {
    width: 30px;
    display: flex;
}

.floating-btn .options {
    position: absolute;
    transform: translate(-20px, 15px) scale(0);
    opacity: 0;
    transition: all 300ms ease;
}

.floating-btn.active .options {
    transform: translate(5px, 5px) scale(1);
    opacity: 1;
}

.floating-btn .option {
    background: #eee;
    padding: 8px 12px;
    border-radius: 8px;
    box-shadow: 0 4px 8px -3px rgba(0, 0, 0, 0.3);
    position: absolute;
}


.floating-btn .option {
    text-decoration: none;
    color: #222;
    user-select: none;
    font-weight: bold;
}

.floating-btn .option:nth-child(1) {
    transform: translate(65px, -30px);
}



.floating-btn .option:nth-child(2) {
    transform: translate(30px, -75px);
}

.floating-btn .option:nth-child(3) {
    transform: translate(65px, 15px);
}

@font-face {
    font-family: IRANSansWeb;
    src: url('../assets/IRANSansWeb.woff2') format("woff2");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: IRANSansWeb;
    src: url('../assets/IRANSansWebBold.woff2') format("woff2");
    font-weight: bold;
    font-style: normal;
}

* {
    font-family: IRANSansWeb;
}

a {
    font-family: IRANSansWeb;
    font-weight: bold;
}

.rtl-dir {
    text-align: start;
    unicode-bidi: plaintext;
}

.user-text {
    max-width: 92vw; /* Takes 90% of the viewport width */
    
}
.user-text * {

    text-align: start !important;
    unicode-bidi: plaintext !important;

}

.ltr-dir {
    text-align: left;
}

.p-chat {
    white-space: pre-line;
}

textarea[autoresize] {
    min-height: 43px;
    max-height: 300px;
    overflow-y: auto;
    resize: none;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border-radius: 9px;
    border: none;
    background: #f8f9fa;
    transition: height 0.1s;
    font-size: 1rem;
    line-height: 1.5;
}

.selected-tool-chip {
    display: inline-block;
    margin-left: 2px;
    vertical-align: middle;
}
.tools-dropdown {
    min-width: 120px;
    max-width: 200px;
    padding: 4px 0;
}
.tools-dropdown > div:hover {
    background: #6355cc;
    color: #fff;
}

@media(min-width:768px) {
    .login-box {
        top: 50%;
        left: 50%;
        position: fixed;
        width: 40vw;
        padding: 10px;
        transform: translate(-50%, -50%);
        z-index: 10000;
        background-color: rgb(24, 24, 24);
        box-sizing: border-box;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
        border-radius: 10px;

    }
}

@media(max-width:767px) {
    .login-box {
        top: 50%;
        left: 50%;
        position: fixed;
        width: 90vw;
        padding: 10px;
        transform: translate(-50%, -50%);
        z-index: 10000;
        background-color: rgb(24, 24, 24);
        box-sizing: border-box;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
        border-radius: 10px;

    }
}

.purchaseSuccess {
    border: 1px solid #9184f7
}

.purchaseSuccess .title {
    color: #9184f7
}

.purchaseSuccess .text {
    line-height: 22px;
}

.purchaseFail .text {
    line-height: 22px;
}

.purchaseAlert .text {
    line-height: 22px;
}

.purchaseSuccess .fa-thumbs-up {
    color: #0abf81;
    border: 1px solid #0abf81;
    top: -15px;
    left: 20px;
}

.purchaseFail {
    border: 1px solid #ff0048
}

.purchaseFail .title {
    color: #ff0048;
}

.fa-light-emergency-on {
    color: #ff0048;
    border: 1px solid #ff0048;
    top: -15px;
    left: 20px;
}

.purchaseAlert {
    border: 1px solid #ff6c00
}

.purchaseAlert .title {
    color: #ff6c00;
}

.fa-diamond-exclamation {
    color: #ff6c00;
    border: 1px solid #ff6c00;
    top: -15px;
    left: 20px;
}

.line-break {
    position: relative;
    margin-top: 10px;
}

.line-break::before {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    border-top: 1px solid #ccc;
    position: absolute;
    top: 50%;
}

.line-break span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 3px 10px;
}

.ramin {
    padding: 1.0rem 0.5rem 1.0rem 0.5rem !important;
}


/* The Modal (background) */
.modal {
    display: block;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 100000;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: hidden;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 512px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 90%;
    }
}
</style>